{
  "openapi": "3.0.0",
  "paths": {
    "/auth/ahead/login": {
      "get": {
        "operationId": "login",
        "parameters": [],
        "responses": {
          "200": {
            "description": ""
          }
        },
        "tags": [
          "Auth / SSO"
        ]
      }
    },
    "/auth/ahead/initiate": {
      "get": {
        "operationId": "initiate",
        "parameters": [],
        "responses": {
          "200": {
            "description": ""
          }
        },
        "tags": [
          "Auth / SSO"
        ]
      }
    },
    "/auth/ahead/callback": {
      "get": {
        "operationId": "callback",
        "parameters": [],
        "responses": {
          "200": {
            "description": ""
          }
        },
        "tags": [
          "Auth / SSO"
        ]
      }
    },
    "/auth/ahead/me": {
      "get": {
        "operationId": "me",
        "parameters": [],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/QiraUserBE"
                }
              }
            }
          }
        },
        "tags": [
          "Auth / SSO"
        ]
      }
    },
    "/auth/ahead/user": {
      "patch": {
        "operationId": "updateUser",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpdateUserDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "type": "object"
                }
              }
            }
          }
        },
        "tags": [
          "Auth / SSO"
        ]
      }
    },
    "/auth/ahead/logout": {
      "get": {
        "operationId": "logout",
        "parameters": [],
        "responses": {
          "200": {
            "description": ""
          }
        },
        "tags": [
          "Auth / SSO"
        ]
      }
    },
    "/auth/ahead/code/generate": {
      "post": {
        "operationId": "generateCode",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/GenerateCodeDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/UserCode"
                }
              }
            }
          }
        },
        "tags": [
          "AuthCodes"
        ]
      }
    },
    "/auth/ahead/code/list": {
      "get": {
        "operationId": "listCodes",
        "parameters": [],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/UserCode"
                  }
                }
              }
            }
          }
        },
        "tags": [
          "AuthCodes"
        ]
      }
    },
    "/auth/ahead/code/login": {
      "post": {
        "operationId": "loginWithCode",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/LoginWithCodeDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/LoginWithCodeResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "AuthCodes"
        ]
      }
    },
    "/auth/ahead/code/deactivate": {
      "post": {
        "operationId": "deactivateCode",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/DeactivateCodeDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": ""
          }
        },
        "tags": [
          "AuthCodes"
        ]
      }
    },
    "/auth/ahead/code/hide": {
      "post": {
        "operationId": "hideCode",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/HideCodeDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": ""
          }
        },
        "tags": [
          "AuthCodes"
        ]
      }
    },
    "/accounts/{id}": {
      "delete": {
        "operationId": "deleteCompany",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "email",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": ""
          }
        },
        "security": [
          {
            "bearer": []
          }
        ],
        "tags": [
          "Account"
        ]
      }
    },
    "/hgs/public-key": {
      "get": {
        "operationId": "getPublicKey",
        "parameters": [],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "type": "string"
                }
              }
            }
          }
        },
        "tags": [
          "HgsPublicKey"
        ]
      }
    },
    "/hgs/documents": {
      "get": {
        "operationId": "getDocument",
        "parameters": [
          {
            "name": "type",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "carTypeId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "carTypeGroup",
            "required": false,
            "in": "query",
            "schema": {
              "enum": [
                "ENGINE",
                "TRANSMISSION",
                "STEERING",
                "BRAKES",
                "EXTERIOR",
                "ELECTRONICS",
                "QUICKGUIDES"
              ],
              "type": "string"
            }
          },
          {
            "name": "location",
            "required": false,
            "in": "query",
            "schema": {
              "enum": [
                5,
                4,
                1,
                2,
                3,
                6
              ],
              "type": "number"
            }
          },
          {
            "name": "storyId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "tsbType",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "systemId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "errorCode",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "vin",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "engineCode",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "mbId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "mbNumber",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "mbInfoTypeCode",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "daily",
            "required": false,
            "in": "query",
            "schema": {
              "type": "boolean"
            }
          },
          {
            "name": "managementSystemId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "componentId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "systemName",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "componentName",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "level",
            "required": false,
            "in": "query",
            "schema": {
              "$ref": "#/components/schemas/Object"
            }
          },
          {
            "name": "systemGroupId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "systemGroupName",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "systems",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/Object"
              }
            }
          },
          {
            "name": "components",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/Object"
              }
            }
          },
          {
            "name": "chapterId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "mainChapterId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "xmlDocumentId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "repairGroupNumber",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "elasticsearchId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "wdGroupNumber",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "guid",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "hgsDocumentId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "documentText",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "hgsSystemId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "language",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "docTitle",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "kType",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "hgsComponentId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "techDataGroupId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "recallHeadline",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "country",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "hgsServiceScheduleId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "parentGroupId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "parentGroupText",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "grandParentGroupId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "grandParentGroupText",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "mainGroupId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "subGroupId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "manualGroupId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "manualId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "qualifierId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "categoryId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "subCategoryId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "genericArticleNo",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "searchTerm",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/HgsArticleOld"
                }
              }
            }
          }
        },
        "security": [
          {
            "bearer": []
          }
        ],
        "tags": [
          "HGS Documents"
        ]
      }
    },
    "/hgs-new/documents": {
      "get": {
        "operationId": "getDocument",
        "parameters": [
          {
            "name": "type",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "carTypeId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "carTypeGroup",
            "required": false,
            "in": "query",
            "schema": {
              "enum": [
                "ENGINE",
                "TRANSMISSION",
                "STEERING",
                "BRAKES",
                "EXTERIOR",
                "ELECTRONICS",
                "QUICKGUIDES"
              ],
              "type": "string"
            }
          },
          {
            "name": "location",
            "required": false,
            "in": "query",
            "schema": {
              "enum": [
                5,
                4,
                1,
                2,
                3,
                6
              ],
              "type": "number"
            }
          },
          {
            "name": "storyId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "tsbType",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "systemId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "errorCode",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "vin",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "engineCode",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "mbId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "mbNumber",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "mbInfoTypeCode",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "daily",
            "required": false,
            "in": "query",
            "schema": {
              "type": "boolean"
            }
          },
          {
            "name": "managementSystemId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "componentId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "systemName",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "componentName",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "level",
            "required": false,
            "in": "query",
            "schema": {
              "$ref": "#/components/schemas/Object"
            }
          },
          {
            "name": "systemGroupId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "systemGroupName",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "systems",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/Object"
              }
            }
          },
          {
            "name": "components",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/Object"
              }
            }
          },
          {
            "name": "chapterId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "mainChapterId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "xmlDocumentId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "repairGroupNumber",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "elasticsearchId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "wdGroupNumber",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "guid",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "hgsDocumentId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "documentText",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "hgsSystemId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "language",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "docTitle",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "kType",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "hgsComponentId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "techDataGroupId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "recallHeadline",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "country",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "hgsServiceScheduleId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "parentGroupId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "parentGroupText",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "grandParentGroupId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "grandParentGroupText",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "mainGroupId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "subGroupId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "manualGroupId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "manualId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "qualifierId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "categoryId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "subCategoryId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "genericArticleNo",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "searchTerm",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "Returns an HGS article document",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/HgsArticle"
                }
              }
            }
          }
        },
        "security": [
          {
            "bearer": []
          }
        ],
        "tags": [
          "HGS Documents"
        ]
      }
    },
    "/hgs-new/proxy-image": {
      "get": {
        "operationId": "proxyImage",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "query",
            "description": "Image ID or Diagram ID",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "type",
            "required": true,
            "in": "query",
            "description": "Type of resource",
            "schema": {
              "enum": [
                "image",
                "wiring-diagram"
              ],
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": ""
          }
        },
        "security": [
          {
            "bearer": []
          }
        ],
        "tags": [
          "HGS Documents"
        ]
      }
    },
    "/vehicles/makes": {
      "get": {
        "operationId": "getMakes",
        "parameters": [],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/Manufacturer"
                  }
                }
              }
            }
          }
        },
        "security": [
          {
            "bearer": []
          }
        ],
        "tags": [
          "Vehicles"
        ]
      }
    },
    "/vehicles/models/{makeId}": {
      "get": {
        "operationId": "getModels",
        "parameters": [
          {
            "name": "makeId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/Model"
                  }
                }
              }
            }
          }
        },
        "security": [
          {
            "bearer": []
          }
        ],
        "tags": [
          "Vehicles"
        ]
      }
    },
    "/vehicles/by-model-id/{makeId}/{modelId}": {
      "get": {
        "operationId": "getVehiclesByModelId",
        "parameters": [
          {
            "name": "makeId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "modelId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/Vehicle"
                  }
                }
              }
            }
          }
        },
        "security": [
          {
            "bearer": []
          }
        ],
        "tags": [
          "Vehicles"
        ]
      }
    },
    "/vehicles/by-car-type-id/{carTypeId}": {
      "get": {
        "operationId": "getVehicleByCarTypeId",
        "parameters": [
          {
            "name": "carTypeId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "Returns a vehicle by carTypeId or null if not found",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Vehicle"
                }
              }
            }
          }
        },
        "security": [
          {
            "bearer": []
          }
        ],
        "tags": [
          "Vehicles"
        ]
      }
    },
    "/vehicles/by-k-type-id/{kTypeId}/{engineCode}": {
      "get": {
        "operationId": "getVehicleByKTypeId",
        "parameters": [
          {
            "name": "kTypeId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "Returns a vehicle by kTypeId or null if not found",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Vehicle"
                }
              }
            }
          }
        },
        "security": [
          {
            "bearer": []
          }
        ],
        "tags": [
          "Vehicles"
        ]
      }
    },
    "/vehicles/by-db/{threadId}": {
      "get": {
        "operationId": "getVehicleFromDB",
        "parameters": [
          {
            "name": "threadId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "Returns a vehicle or null if not found / Fallback function",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Vehicle"
                }
              }
            }
          }
        },
        "security": [
          {
            "bearer": []
          }
        ],
        "tags": [
          "Vehicles"
        ]
      }
    },
    "/vehicles/by-kba/{kba}": {
      "get": {
        "operationId": "getVehicleByKBA",
        "parameters": [
          {
            "name": "kba",
            "required": true,
            "in": "path",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/Vehicle"
                  }
                }
              }
            }
          }
        },
        "security": [
          {
            "bearer": []
          }
        ],
        "tags": [
          "Vehicles"
        ]
      }
    },
    "/vehicles/by-vin/{vin}": {
      "get": {
        "operationId": "getVehicleByVIN",
        "parameters": [
          {
            "name": "vin",
            "required": true,
            "in": "path",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/Vehicle"
                  }
                }
              }
            }
          }
        },
        "security": [
          {
            "bearer": []
          }
        ],
        "tags": [
          "Vehicles"
        ]
      }
    },
    "/vehicles/by-tecdoc/{tdid}": {
      "get": {
        "operationId": "getVehicleByTecDoc",
        "parameters": [
          {
            "name": "tdid",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/HpWSIdentificationElement"
                  }
                }
              }
            }
          }
        },
        "security": [
          {
            "bearer": []
          }
        ],
        "tags": [
          "Vehicles"
        ]
      }
    },
    "/threads": {
      "post": {
        "operationId": "create",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CreateThreadDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Thread"
                }
              }
            }
          }
        },
        "security": [
          {
            "bearer": []
          }
        ],
        "tags": [
          "Threads"
        ]
      },
      "get": {
        "operationId": "findAll",
        "parameters": [
          {
            "name": "additionalThreadId",
            "required": false,
            "in": "query",
            "description": "Optionally include an additional thread by ID (intended for admin use).",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/ThreadWithoutMessagesDto"
                  }
                }
              }
            }
          }
        },
        "security": [
          {
            "bearer": []
          }
        ],
        "tags": [
          "Threads"
        ]
      }
    },
    "/threads/{id}": {
      "get": {
        "operationId": "findOne",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Thread"
                }
              }
            }
          }
        },
        "security": [
          {
            "bearer": []
          }
        ],
        "tags": [
          "Threads"
        ]
      },
      "patch": {
        "operationId": "update",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "string"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpdateThreadDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": ""
          }
        },
        "security": [
          {
            "bearer": []
          }
        ],
        "tags": [
          "Threads"
        ]
      },
      "delete": {
        "operationId": "remove",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": ""
          }
        },
        "security": [
          {
            "bearer": []
          }
        ],
        "tags": [
          "Threads"
        ]
      }
    },
    "/threads/{id}/messages": {
      "post": {
        "operationId": "createMessage",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "string"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CreateMessageDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/QiraMessage"
                }
              }
            }
          }
        },
        "security": [
          {
            "bearer": []
          }
        ],
        "tags": [
          "Threads"
        ]
      },
      "get": {
        "operationId": "findAllMessages",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "created_after",
            "required": false,
            "in": "query",
            "description": "Return messages created after this date/time",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/QiraMessage"
                  }
                }
              }
            }
          }
        },
        "security": [
          {
            "bearer": []
          }
        ],
        "tags": [
          "Threads"
        ]
      }
    },
    "/threads/{id}/messages/{messageId}": {
      "get": {
        "operationId": "findMessage",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "messageId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/QiraMessage"
                }
              }
            }
          }
        },
        "security": [
          {
            "bearer": []
          }
        ],
        "tags": [
          "Threads"
        ]
      },
      "patch": {
        "operationId": "updateMessage",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "messageId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "string"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpdateMessageDto"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/QiraMessage"
                }
              }
            }
          }
        },
        "security": [
          {
            "bearer": []
          }
        ],
        "tags": [
          "Threads"
        ]
      },
      "delete": {
        "operationId": "removeMessage",
        "parameters": [
          {
            "name": "id",
            "required": true,
            "in": "path",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "messageId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": ""
          }
        },
        "security": [
          {
            "bearer": []
          }
        ],
        "tags": [
          "Threads"
        ]
      }
    },
    "/rmi/hp/navigation/{carTypeId}": {
      "get": {
        "operationId": "getNavigation",
        "parameters": [
          {
            "name": "carTypeId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/NavigationItem"
                  }
                }
              }
            }
          }
        },
        "security": [
          {
            "bearer": []
          }
        ],
        "tags": [
          "Navigation"
        ]
      }
    },
    "/rmi/mb/proxy-image": {
      "get": {
        "operationId": "proxyImage",
        "parameters": [
          {
            "name": "url",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": ""
          }
        },
        "tags": [
          "Mercedes"
        ]
      }
    },
    "/voice/stream/{threadId}/{messageId}": {
      "get": {
        "operationId": "streamVoice",
        "parameters": [
          {
            "name": "threadId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "messageId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": ""
          }
        },
        "security": [
          {
            "bearer": []
          }
        ],
        "tags": [
          "Voice"
        ]
      }
    },
    "/event-tracker/event": {
      "post": {
        "operationId": "logEvent",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/QiraEventLegacy"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "type": "boolean"
                }
              }
            }
          }
        },
        "tags": [
          "Event-Tracker"
        ]
      }
    },
    "/event-tracker-internal/event-internal": {
      "post": {
        "operationId": "trackEvent",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/QiraEvent"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": ""
          }
        },
        "summary": "Track a frontend event",
        "tags": [
          "Event-Tracker-Internal"
        ]
      }
    },
    "/rmi/hp/documents": {
      "get": {
        "operationId": "getDocuments",
        "parameters": [
          {
            "name": "type",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "carTypeId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "carTypeGroup",
            "required": false,
            "in": "query",
            "schema": {
              "enum": [
                "ENGINE",
                "TRANSMISSION",
                "STEERING",
                "BRAKES",
                "EXTERIOR",
                "ELECTRONICS",
                "QUICKGUIDES"
              ],
              "type": "string"
            }
          },
          {
            "name": "location",
            "required": false,
            "in": "query",
            "schema": {
              "enum": [
                5,
                4,
                1,
                2,
                3,
                6
              ],
              "type": "number"
            }
          },
          {
            "name": "storyId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "tsbType",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "systemId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "errorCode",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "vin",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "engineCode",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "mbId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "mbNumber",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "mbInfoTypeCode",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "daily",
            "required": false,
            "in": "query",
            "schema": {
              "type": "boolean"
            }
          },
          {
            "name": "managementSystemId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "componentId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "systemName",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "componentName",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "level",
            "required": false,
            "in": "query",
            "schema": {
              "$ref": "#/components/schemas/Object"
            }
          },
          {
            "name": "systemGroupId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "systemGroupName",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "systems",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/Object"
              }
            }
          },
          {
            "name": "components",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/Object"
              }
            }
          },
          {
            "name": "chapterId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "mainChapterId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "xmlDocumentId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "repairGroupNumber",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "elasticsearchId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "wdGroupNumber",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "guid",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "hgsDocumentId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "documentText",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "hgsSystemId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "language",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "docTitle",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "kType",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "hgsComponentId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "techDataGroupId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "recallHeadline",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "country",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "hgsServiceScheduleId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "parentGroupId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "parentGroupText",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "grandParentGroupId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "grandParentGroupText",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "mainGroupId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "subGroupId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "manualGroupId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "manualId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "qualifierId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "categoryId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "subCategoryId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "genericArticleNo",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "searchTerm",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/HpArticle"
                  }
                }
              }
            }
          }
        },
        "security": [
          {
            "bearer": []
          }
        ],
        "tags": [
          "HaynesPro Documents"
        ]
      }
    },
    "/rmi/hp/search-entries": {
      "get": {
        "operationId": "getSearchEntries",
        "parameters": [
          {
            "name": "type",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "carTypeId",
            "required": true,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "searchEntryId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/SearchEntry"
                  }
                }
              }
            }
          }
        },
        "security": [
          {
            "bearer": []
          }
        ],
        "tags": [
          "HaynesPro Search Entries"
        ]
      }
    },
    "/payment/webhook": {
      "post": {
        "operationId": "webhook",
        "parameters": [],
        "responses": {
          "201": {
            "description": ""
          }
        },
        "tags": [
          "Payment"
        ]
      }
    },
    "/payment/checkAllCheckouts": {
      "get": {
        "operationId": "missedSessions",
        "parameters": [
          {
            "name": "checkoutSessionId",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "Check for all missed sessions",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SuccessResponseDto"
                }
              }
            }
          }
        },
        "tags": [
          "Payment"
        ]
      }
    },
    "/payment/allProducts": {
      "get": {
        "operationId": "allActiveProducts",
        "parameters": [],
        "responses": {
          "200": {
            "description": "List of active products",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/EnhancedProductDto"
                  }
                }
              }
            }
          }
        },
        "summary": "Get all active products with their prices",
        "tags": [
          "Payment"
        ]
      }
    },
    "/payment/billingPortal": {
      "get": {
        "operationId": "getCustomerPortal",
        "parameters": [
          {
            "name": "qiraCompanyId",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "type": "object"
                }
              }
            }
          }
        },
        "tags": [
          "Payment"
        ]
      }
    },
    "/health": {
      "get": {
        "operationId": "check",
        "parameters": [],
        "responses": {
          "200": {
            "description": ""
          }
        },
        "tags": [
          "Health"
        ]
      }
    },
    "/rmi/hp/wiring-diagrams/diagnosisForErrorCode/{carTypeId}/{errorCode}": {
      "get": {
        "operationId": "getDiagnosisForErrorCode",
        "parameters": [
          {
            "name": "carTypeId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "errorCode",
            "required": true,
            "in": "path",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/AffectedDiagnostic"
                  }
                }
              }
            }
          }
        },
        "security": [
          {
            "bearer": []
          }
        ],
        "tags": [
          "HPWiringDiagrams"
        ]
      }
    },
    "/rmi/hp/wiring-diagrams/variantGroupComponentsForErrorCode/{carTypeId}/{errorCode}": {
      "get": {
        "operationId": "getVariantGroupsWithComponentsForErrorCode",
        "parameters": [
          {
            "name": "carTypeId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "errorCode",
            "required": true,
            "in": "path",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/VariantGroupsWithComponents"
                }
              }
            }
          }
        },
        "security": [
          {
            "bearer": []
          }
        ],
        "tags": [
          "HPWiringDiagrams"
        ]
      }
    },
    "/rmi/hp/wiring-diagrams/getComponentsByIds": {
      "post": {
        "operationId": "getComponentsByIds",
        "parameters": [],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/GetWiringDiagramComponentsDTO"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/VariantGroupsWithComponents"
                }
              }
            }
          }
        },
        "security": [
          {
            "bearer": []
          }
        ],
        "tags": [
          "HPWiringDiagrams"
        ]
      }
    },
    "/rmi/hp/wiring-diagrams/completeDiagnosticComponent/{carTypeId}/{symbolInstanceId}/{systemTypeId}": {
      "get": {
        "operationId": "getCompleteDiagnosticComponent",
        "parameters": [
          {
            "name": "carTypeId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "symbolInstanceId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "systemTypeId",
            "required": true,
            "in": "path",
            "schema": {
              "type": "number"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/HpCompleteComponentV10"
                }
              }
            }
          }
        },
        "security": [
          {
            "bearer": []
          }
        ],
        "tags": [
          "HPWiringDiagrams"
        ]
      }
    },
    "/rmi/mb/documents/html": {
      "get": {
        "operationId": "getMBDocuments",
        "parameters": [
          {
            "name": "type",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "carTypeId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "carTypeGroup",
            "required": false,
            "in": "query",
            "schema": {
              "enum": [
                "ENGINE",
                "TRANSMISSION",
                "STEERING",
                "BRAKES",
                "EXTERIOR",
                "ELECTRONICS",
                "QUICKGUIDES"
              ],
              "type": "string"
            }
          },
          {
            "name": "location",
            "required": false,
            "in": "query",
            "schema": {
              "enum": [
                5,
                4,
                1,
                2,
                3,
                6
              ],
              "type": "number"
            }
          },
          {
            "name": "storyId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "tsbType",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "systemId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "errorCode",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "vin",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "engineCode",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "mbId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "mbNumber",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "mbInfoTypeCode",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "daily",
            "required": false,
            "in": "query",
            "schema": {
              "type": "boolean"
            }
          },
          {
            "name": "managementSystemId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "componentId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "systemName",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "componentName",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "level",
            "required": false,
            "in": "query",
            "schema": {
              "$ref": "#/components/schemas/Object"
            }
          },
          {
            "name": "systemGroupId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "systemGroupName",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "systems",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/Object"
              }
            }
          },
          {
            "name": "components",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/Object"
              }
            }
          },
          {
            "name": "chapterId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "mainChapterId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "xmlDocumentId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "repairGroupNumber",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "elasticsearchId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "wdGroupNumber",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "guid",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "hgsDocumentId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "documentText",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "hgsSystemId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "language",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "docTitle",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "kType",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "hgsComponentId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "techDataGroupId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "recallHeadline",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "country",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "hgsServiceScheduleId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "parentGroupId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "parentGroupText",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "grandParentGroupId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "grandParentGroupText",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "mainGroupId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "subGroupId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "manualGroupId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "manualId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "qualifierId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "categoryId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "subCategoryId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "genericArticleNo",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "searchTerm",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "type": "object"
                }
              }
            }
          }
        },
        "security": [
          {
            "bearer": []
          }
        ],
        "tags": [
          "Mercedes Documents"
        ]
      }
    },
    "/rmi/mb/documents/pdf": {
      "get": {
        "operationId": "getMBDocumentsPDF",
        "parameters": [
          {
            "name": "type",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "carTypeId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "carTypeGroup",
            "required": false,
            "in": "query",
            "schema": {
              "enum": [
                "ENGINE",
                "TRANSMISSION",
                "STEERING",
                "BRAKES",
                "EXTERIOR",
                "ELECTRONICS",
                "QUICKGUIDES"
              ],
              "type": "string"
            }
          },
          {
            "name": "location",
            "required": false,
            "in": "query",
            "schema": {
              "enum": [
                5,
                4,
                1,
                2,
                3,
                6
              ],
              "type": "number"
            }
          },
          {
            "name": "storyId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "tsbType",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "systemId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "errorCode",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "vin",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "engineCode",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "mbId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "mbNumber",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "mbInfoTypeCode",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "daily",
            "required": false,
            "in": "query",
            "schema": {
              "type": "boolean"
            }
          },
          {
            "name": "managementSystemId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "componentId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "systemName",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "componentName",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "level",
            "required": false,
            "in": "query",
            "schema": {
              "$ref": "#/components/schemas/Object"
            }
          },
          {
            "name": "systemGroupId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "systemGroupName",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "systems",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/Object"
              }
            }
          },
          {
            "name": "components",
            "required": false,
            "in": "query",
            "schema": {
              "type": "array",
              "items": {
                "$ref": "#/components/schemas/Object"
              }
            }
          },
          {
            "name": "chapterId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "mainChapterId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "xmlDocumentId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "repairGroupNumber",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "elasticsearchId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "wdGroupNumber",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "guid",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "hgsDocumentId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "documentText",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "hgsSystemId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "language",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "docTitle",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "kType",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "hgsComponentId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "techDataGroupId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "recallHeadline",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "country",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "hgsServiceScheduleId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "number"
            }
          },
          {
            "name": "parentGroupId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "parentGroupText",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "grandParentGroupId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "grandParentGroupText",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "mainGroupId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "subGroupId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "manualGroupId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "manualId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "qualifierId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "categoryId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "subCategoryId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "genericArticleNo",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "searchTerm",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": ""
          }
        },
        "security": [
          {
            "bearer": []
          }
        ],
        "tags": [
          "Mercedes Documents"
        ]
      }
    },
    "/rmi/vw/get-by-elasticsearch-id": {
      "get": {
        "operationId": "getVWByElasticsearchId",
        "parameters": [
          {
            "name": "elasticsearchId",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ElasticEntry"
                }
              }
            }
          }
        },
        "security": [
          {
            "bearer": []
          }
        ],
        "tags": [
          "VW"
        ]
      }
    },
    "/rmi/vw/by-id": {
      "get": {
        "operationId": "getVWById",
        "parameters": [
          {
            "name": "wdGroupNumber",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/WDElasticEntry"
                }
              }
            }
          }
        },
        "security": [
          {
            "bearer": []
          }
        ],
        "tags": [
          "VW"
        ]
      }
    },
    "/rmi/vw/proxy-image": {
      "get": {
        "operationId": "proxyVolkswagenImage",
        "parameters": [
          {
            "name": "vehicleId",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "imageId",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "subject",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": ""
          }
        },
        "security": [
          {
            "bearer": []
          }
        ],
        "tags": [
          "VW"
        ]
      }
    },
    "/rmi/skoda/get-by-elasticsearch-id": {
      "get": {
        "operationId": "getSkodaByElasticsearchId",
        "parameters": [
          {
            "name": "elasticsearchId",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SkodaElasticEntry"
                }
              }
            }
          }
        },
        "security": [
          {
            "bearer": []
          }
        ],
        "tags": [
          "Skoda"
        ]
      }
    },
    "/rmi/skoda/by-id": {
      "get": {
        "operationId": "getSkodaById",
        "parameters": [
          {
            "name": "chapterId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "xmlDocumentId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "mainChapterId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "repairGroupNumber",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "wdGroupNumber",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "type": "object"
                }
              }
            }
          }
        },
        "security": [
          {
            "bearer": []
          }
        ],
        "tags": [
          "Skoda"
        ]
      }
    },
    "/rmi/skoda/proxy-image": {
      "get": {
        "operationId": "proxySkodaImage",
        "parameters": [
          {
            "name": "vehicleId",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "imageId",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "subject",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": ""
          }
        },
        "security": [
          {
            "bearer": []
          }
        ],
        "tags": [
          "Skoda"
        ]
      }
    },
    "/rmi/seat/get-by-elasticsearch-id": {
      "get": {
        "operationId": "getSeatByElasticsearchId",
        "parameters": [
          {
            "name": "elasticsearchId",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SeatElasticEntry"
                }
              }
            }
          }
        },
        "security": [
          {
            "bearer": []
          }
        ],
        "tags": [
          "Seat"
        ]
      }
    },
    "/rmi/seat/by-id": {
      "get": {
        "operationId": "getSeatById",
        "parameters": [
          {
            "name": "chapterId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "xmlDocumentId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "mainChapterId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "repairGroupNumber",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "wdGroupNumber",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "type": "object"
                }
              }
            }
          }
        },
        "security": [
          {
            "bearer": []
          }
        ],
        "tags": [
          "Seat"
        ]
      }
    },
    "/rmi/seat/proxy-image": {
      "get": {
        "operationId": "proxySeatImage",
        "parameters": [
          {
            "name": "vehicleId",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "imageId",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "subject",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": ""
          }
        },
        "security": [
          {
            "bearer": []
          }
        ],
        "tags": [
          "Seat"
        ]
      }
    },
    "/rmi/audi/get-by-elasticsearch-id": {
      "get": {
        "operationId": "getAudiByElasticsearchId",
        "parameters": [
          {
            "name": "elasticsearchId",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/AudiElasticEntry"
                }
              }
            }
          }
        },
        "security": [
          {
            "bearer": []
          }
        ],
        "tags": [
          "Audi"
        ]
      }
    },
    "/rmi/audi/by-id": {
      "get": {
        "operationId": "getAudiById",
        "parameters": [
          {
            "name": "chapterId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "xmlDocumentId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "mainChapterId",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "repairGroupNumber",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "wdGroupNumber",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "type": "object"
                }
              }
            }
          }
        },
        "security": [
          {
            "bearer": []
          }
        ],
        "tags": [
          "Audi"
        ]
      }
    },
    "/rmi/audi/proxy-image": {
      "get": {
        "operationId": "proxyAudiImage",
        "parameters": [
          {
            "name": "vehicleId",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "imageId",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "subject",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": ""
          }
        },
        "security": [
          {
            "bearer": []
          }
        ],
        "tags": [
          "Audi"
        ]
      }
    },
    "/rmi/tesla/by-id": {
      "get": {
        "operationId": "getTeslaById",
        "parameters": [
          {
            "name": "guid",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/TeslaEntry"
                }
              }
            }
          }
        },
        "security": [
          {
            "bearer": []
          }
        ],
        "tags": [
          "Tesla"
        ]
      }
    },
    "/rmi/tesla/search": {
      "get": {
        "operationId": "searchTeslaDocuments",
        "parameters": [
          {
            "name": "query",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "model",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "yearRange",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/TeslaEntry"
                  }
                }
              }
            }
          }
        },
        "security": [
          {
            "bearer": []
          }
        ],
        "tags": [
          "Tesla"
        ]
      }
    },
    "/rmi/tesla/proxy-image": {
      "get": {
        "operationId": "proxyTeslaImage",
        "parameters": [
          {
            "name": "imageId",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "model",
            "required": false,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": ""
          }
        },
        "security": [
          {
            "bearer": []
          }
        ],
        "tags": [
          "Tesla"
        ]
      }
    },
    "/": {
      "get": {
        "operationId": "redirectToBackoffice",
        "parameters": [],
        "responses": {
          "200": {
            "description": ""
          }
        },
        "tags": [
          "BackofficeAuth"
        ]
      }
    },
    "/callback": {
      "get": {
        "operationId": "backofficeCallback",
        "parameters": [],
        "responses": {
          "200": {
            "description": ""
          }
        },
        "tags": [
          "BackofficeAuth"
        ]
      }
    },
    "/backoffice": {
      "get": {
        "operationId": "getBackoffice",
        "parameters": [],
        "responses": {
          "200": {
            "description": ""
          }
        },
        "tags": [
          "BackofficeAuth"
        ]
      }
    },
    "/backoffice/user": {
      "get": {
        "operationId": "getQiraBackoffice",
        "parameters": [],
        "responses": {
          "200": {
            "description": ""
          }
        },
        "tags": [
          "BackofficeUsers"
        ]
      }
    },
    "/backoffice/user/update": {
      "patch": {
        "operationId": "updateQiraUser",
        "parameters": [],
        "responses": {
          "200": {
            "description": ""
          }
        },
        "tags": [
          "BackofficeUsers"
        ]
      },
      "post": {
        "operationId": "updateQiraUserPost",
        "parameters": [],
        "responses": {
          "201": {
            "description": ""
          }
        },
        "tags": [
          "BackofficeUsers"
        ]
      }
    },
    "/backoffice/vocab": {
      "get": {
        "operationId": "getQiraVocabAdmin",
        "parameters": [],
        "responses": {
          "200": {
            "description": ""
          }
        },
        "tags": [
          "BackofficeVocab"
        ]
      }
    },
    "/backoffice/vocab/create": {
      "post": {
        "operationId": "createNormalizationVocabEntry",
        "parameters": [],
        "responses": {
          "201": {
            "description": ""
          }
        },
        "tags": [
          "BackofficeVocab"
        ]
      }
    },
    "/backoffice/vocab/update": {
      "post": {
        "operationId": "updateNormalizationVocabEntry",
        "parameters": [],
        "responses": {
          "201": {
            "description": ""
          }
        },
        "tags": [
          "BackofficeVocab"
        ]
      }
    },
    "/backoffice/vocab/delete": {
      "post": {
        "operationId": "deleteNormalizationVocabEntry",
        "parameters": [],
        "responses": {
          "201": {
            "description": ""
          }
        },
        "tags": [
          "BackofficeVocab"
        ]
      }
    },
    "/backoffice/feature-flags": {
      "get": {
        "operationId": "getFeatureFlagsAdmin",
        "parameters": [],
        "responses": {
          "200": {
            "description": ""
          }
        },
        "tags": [
          "BackofficeFeatureFlags"
        ]
      }
    },
    "/backoffice/feature-flags/update": {
      "post": {
        "operationId": "updateFeatureFlag",
        "parameters": [],
        "responses": {
          "201": {
            "description": ""
          }
        },
        "tags": [
          "BackofficeFeatureFlags"
        ]
      }
    },
    "/backoffice/feature-flags/reset": {
      "post": {
        "operationId": "resetFeatureFlag",
        "parameters": [],
        "responses": {
          "201": {
            "description": ""
          }
        },
        "tags": [
          "BackofficeFeatureFlags"
        ]
      }
    },
    "/backoffice/cutover-flags": {
      "get": {
        "operationId": "getCutoverFlagsAdmin",
        "parameters": [],
        "responses": {
          "200": {
            "description": ""
          }
        },
        "tags": [
          "BackofficeCutoverFlags"
        ]
      }
    },
    "/backoffice/cutover-flags/update": {
      "post": {
        "operationId": "updateCutoverFlag",
        "parameters": [],
        "responses": {
          "201": {
            "description": ""
          }
        },
        "tags": [
          "BackofficeCutoverFlags"
        ]
      }
    },
    "/backoffice/cutover-flags/primary-store": {
      "post": {
        "operationId": "updatePrimaryStore",
        "parameters": [],
        "responses": {
          "201": {
            "description": ""
          }
        },
        "tags": [
          "BackofficeCutoverFlags"
        ]
      }
    },
    "/backoffice/cutover-flags/reset": {
      "post": {
        "operationId": "resetCutoverFlag",
        "parameters": [],
        "responses": {
          "201": {
            "description": ""
          }
        },
        "tags": [
          "BackofficeCutoverFlags"
        ]
      }
    },
    "/status": {
      "get": {
        "operationId": "getStatus",
        "parameters": [],
        "responses": {
          "200": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "type": "object"
                }
              }
            }
          }
        },
        "security": [
          {
            "bearer": []
          }
        ],
        "tags": [
          "Status"
        ]
      }
    },
    "/status/health": {
      "get": {
        "operationId": "getHealthStatus",
        "parameters": [],
        "responses": {
          "200": {
            "description": "Service health status with colors",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/ServiceHealthStatus"
                  }
                }
              }
            }
          }
        },
        "security": [
          {
            "bearer": []
          }
        ],
        "tags": [
          "Status"
        ]
      }
    },
    "/knowledge/vw-knowledge": {
      "get": {
        "operationId": "getVWData",
        "parameters": [
          {
            "name": "vehicleId",
            "required": true,
            "in": "query",
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": ""
          }
        },
        "security": [
          {
            "bearer": []
          }
        ],
        "tags": [
          "Knowledge"
        ]
      }
    },
    "/vision/vinFromImage": {
      "post": {
        "operationId": "getVinFromImage",
        "parameters": [],
        "requestBody": {
          "required": true,
          "description": "Upload image file",
          "content": {
            "multipart/form-data": {
              "schema": {
                "$ref": "#/components/schemas/ImageFileDto"
              }
            }
          }
        },
        "responses": {
          "201": {
            "description": "",
            "content": {
              "application/json": {
                "schema": {
                  "type": "string"
                }
              }
            }
          }
        },
        "tags": [
          "Vision"
        ]
      }
    },
    "/metrics": {
      "get": {
        "operationId": "index",
        "parameters": [],
        "responses": {
          "200": {
            "description": ""
          }
        },
        "tags": [
          "Prometheus"
        ]
      }
    }
  },
  "info": {
    "title": "QIRA API",
    "description": "API Documentation for QIRA",
    "version": "1.0",
    "contact": {}
  },
  "tags": [],
  "servers": [],
  "components": {
    "securitySchemes": {
      "bearer": {
        "scheme": "bearer",
        "bearerFormat": "JWT",
        "type": "http"
      }
    },
    "schemas": {
      "AheadUser": {
        "type": "object",
        "properties": {
          "id": {
            "type": "string"
          },
          "email": {
            "type": "string"
          },
          "first_name": {
            "type": "string"
          },
          "last_name": {
            "type": "string"
          },
          "user_type": {
            "type": "string"
          },
          "state": {
            "type": "string"
          },
          "created_at": {
            "type": "string"
          },
          "updated_at": {
            "type": "string"
          },
          "company_id": {
            "type": "string"
          },
          "phone_number": {
            "type": "string",
            "nullable": true
          },
          "salutation": {
            "type": "string",
            "nullable": true
          },
          "roles": {
            "type": "array",
            "items": {
              "type": "string"
            }
          },
          "default_scope": {
            "type": "string"
          }
        },
        "required": [
          "id",
          "email",
          "first_name",
          "last_name",
          "company_id"
        ]
      },
      "AheadCompany": {
        "type": "object",
        "properties": {
          "id": {
            "type": "string"
          },
          "created_at": {
            "type": "string"
          },
          "updated_at": {
            "type": "string"
          },
          "num_of_employees": {
            "type": "number",
            "nullable": true
          },
          "num_of_platforms": {
            "type": "number",
            "nullable": true
          },
          "qira_joined_at": {
            "type": "string",
            "nullable": true
          },
          "country_code": {
            "type": "string",
            "nullable": true
          },
          "qira": {
            "type": "boolean",
            "nullable": true
          },
          "propoints": {
            "type": "boolean",
            "nullable": true
          },
          "partner_code": {
            "type": "string",
            "nullable": true
          },
          "name": {
            "type": "string"
          },
          "vat_number": {
            "type": "string",
            "nullable": true
          },
          "address_line_1": {
            "type": "string",
            "nullable": true
          },
          "address_line_2": {
            "type": "string",
            "nullable": true
          },
          "city": {
            "type": "string",
            "nullable": true
          },
          "zip": {
            "type": "string",
            "nullable": true
          }
        },
        "required": [
          "id",
          "name"
        ]
      },
      "SubscriptionPlan": {
        "type": "string",
        "enum": [
          "trial",
          "professional",
          "enterprise"
        ]
      },
      "UserSubscriptionData": {
        "type": "object",
        "properties": {
          "_id": {
            "type": "string",
            "description": "MongoDB ObjectId as string"
          },
          "plan": {
            "description": "The subscription plan type",
            "example": "trial",
            "allOf": [
              {
                "$ref": "#/components/schemas/SubscriptionPlan"
              }
            ]
          },
          "companyId": {
            "type": "string"
          },
          "stripeCustomerId": {
            "type": "string",
            "nullable": true
          },
          "trialStart": {
            "format": "date-time",
            "type": "string"
          },
          "trialEnd": {
            "format": "date-time",
            "type": "string"
          },
          "subStart": {
            "format": "date-time",
            "type": "string",
            "nullable": true
          },
          "endOfSub": {
            "format": "date-time",
            "type": "string",
            "nullable": true
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          }
        },
        "required": [
          "_id",
          "plan",
          "companyId",
          "stripeCustomerId",
          "trialStart",
          "trialEnd",
          "subStart",
          "endOfSub",
          "createdAt",
          "updatedAt"
        ]
      },
      "QiraUserBE": {
        "type": "object",
        "properties": {
          "userId": {
            "type": "string"
          },
          "codeId": {
            "type": "string"
          },
          "profile": {
            "$ref": "#/components/schemas/AheadUser"
          },
          "company": {
            "$ref": "#/components/schemas/AheadCompany"
          },
          "subscription": {
            "$ref": "#/components/schemas/UserSubscriptionData"
          },
          "qiraRole": {
            "type": "string",
            "enum": [
              "ADMIN",
              "DEVICE"
            ]
          },
          "isAdmin": {
            "type": "boolean"
          }
        },
        "required": [
          "userId",
          "profile",
          "company",
          "subscription",
          "qiraRole"
        ]
      },
      "UpdateCompanyDto": {
        "type": "object",
        "properties": {
          "address_line_1": {
            "type": "string",
            "nullable": true
          },
          "address_line_2": {
            "type": "string",
            "nullable": true
          },
          "zip": {
            "type": "string",
            "nullable": true
          },
          "city": {
            "type": "string",
            "nullable": true
          },
          "name": {
            "type": "string",
            "nullable": true
          },
          "vat_number": {
            "type": "string",
            "nullable": true
          },
          "num_of_employees": {
            "type": "number",
            "nullable": true
          },
          "num_of_platforms": {
            "type": "number",
            "nullable": true
          },
          "partner_code": {
            "type": "string",
            "nullable": true
          }
        }
      },
      "UpdateUserDto": {
        "type": "object",
        "properties": {
          "first_name": {
            "type": "string"
          },
          "last_name": {
            "type": "string"
          },
          "user_type": {
            "type": "string"
          },
          "state": {
            "type": "string"
          },
          "created_at": {
            "type": "string"
          },
          "updated_at": {
            "type": "string"
          },
          "phone_number": {
            "type": "string",
            "nullable": true
          },
          "company": {
            "$ref": "#/components/schemas/UpdateCompanyDto"
          },
          "salutation": {
            "type": "string"
          }
        }
      },
      "GenerateCodeDto": {
        "type": "object",
        "properties": {
          "note": {
            "type": "string"
          }
        }
      },
      "UserCode": {
        "type": "object",
        "properties": {
          "_id": {
            "type": "string"
          },
          "code": {
            "type": "string"
          },
          "note": {
            "type": "string"
          },
          "ownerUserId": {
            "type": "string"
          },
          "isActive": {
            "type": "boolean"
          },
          "isDeactivated": {
            "type": "boolean"
          },
          "isLoggedOut": {
            "type": "boolean"
          },
          "isHidden": {
            "type": "boolean"
          },
          "usedAt": {
            "type": "string"
          },
          "usedByDevice": {
            "type": "string"
          },
          "createdAt": {
            "format": "date-time",
            "type": "string"
          },
          "updatedAt": {
            "format": "date-time",
            "type": "string"
          }
        },
        "required": [
          "_id",
          "code",
          "ownerUserId",
          "isActive",
          "isDeactivated",
          "isLoggedOut",
          "isHidden",
          "createdAt",
          "updatedAt"
        ]
      },
      "LoginWithCodeDto": {
        "type": "object",
        "properties": {
          "code": {
            "type": "string"
          }
        },
        "required": [
          "code"
        ]
      },
      "LoginWithCodeResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean"
          }
        },
        "required": [
          "success"
        ]
      },
      "DeactivateCodeDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "string"
          }
        },
        "required": [
          "id"
        ]
      },
      "HideCodeDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "string"
          }
        },
        "required": [
          "id"
        ]
      },
      "Object": {
        "type": "object",
        "properties": {}
      },
      "HgsArticleOld": {
        "type": "object",
        "properties": {
          "text": {
            "type": "string"
          },
          "data": {
            "type": "object"
          }
        },
        "required": [
          "text"
        ]
      },
      "HgsManufacturer": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "name": {
            "type": "string"
          }
        },
        "required": [
          "id",
          "name"
        ]
      },
      "HgsDrivetrain": {
        "type": "object",
        "properties": {
          "engineCode": {
            "type": "string"
          },
          "engineHp": {
            "type": "number"
          },
          "engineKw": {
            "type": "number"
          },
          "propulsionType": {
            "type": "string"
          },
          "propulsionTypeName": {
            "type": "string"
          },
          "cylinders": {
            "type": "number"
          }
        },
        "required": [
          "engineCode",
          "engineHp",
          "engineKw",
          "propulsionType",
          "propulsionTypeName",
          "cylinders"
        ]
      },
      "HgsModel": {
        "type": "object",
        "properties": {
          "modelId": {
            "type": "number"
          },
          "modelType": {
            "type": "string"
          },
          "engineSize": {
            "type": "number"
          },
          "modelSeriesName": {
            "type": "string"
          },
          "modelName": {
            "type": "string"
          },
          "typeOfVehicle": {
            "type": "string"
          },
          "regionCode": {
            "type": "string"
          },
          "fromYear": {
            "type": "number"
          },
          "toYear": {
            "type": "number"
          },
          "electronicOEServiceRegistrationTId": {
            "type": "number"
          }
        },
        "required": [
          "modelId",
          "modelType",
          "engineSize",
          "modelSeriesName",
          "modelName",
          "typeOfVehicle",
          "regionCode",
          "fromYear",
          "toYear",
          "electronicOEServiceRegistrationTId"
        ]
      },
      "HgsVehicleType": {
        "type": "object",
        "properties": {
          "kTypeNo": {
            "type": "number"
          }
        },
        "required": [
          "kTypeNo"
        ]
      },
      "VehicleReference": {
        "type": "object",
        "properties": {
          "hgs": {
            "type": "object",
            "properties": {
              "manufacturer": {
                "$ref": "#/components/schemas/HgsManufacturer"
              },
              "drivetrain": {
                "$ref": "#/components/schemas/HgsDrivetrain"
              },
              "model": {
                "$ref": "#/components/schemas/HgsModel"
              }
            },
            "required": [
              "manufacturer",
              "drivetrain",
              "model"
            ]
          },
          "tecDoc": {
            "type": "object",
            "properties": {
              "vehicleType": {
                "$ref": "#/components/schemas/HgsVehicleType"
              }
            },
            "required": [
              "vehicleType"
            ]
          }
        },
        "required": [
          "hgs",
          "tecDoc"
        ]
      },
      "Translation": {
        "type": "object",
        "properties": {
          "language": {
            "type": "string"
          },
          "title": {
            "type": "string"
          },
          "text": {
            "type": "string"
          },
          "systemName": {
            "type": "string"
          }
        },
        "required": [
          "language"
        ]
      },
      "CompartmentComponent": {
        "type": "object",
        "properties": {
          "componentId": {
            "type": "string"
          },
          "shortName": {
            "type": "string"
          },
          "name": {
            "$ref": "#/components/schemas/Translation"
          },
          "group": {
            "$ref": "#/components/schemas/Translation"
          },
          "imageUrl": {
            "type": "string"
          },
          "placementText": {
            "$ref": "#/components/schemas/Translation"
          },
          "genericArticleNos": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "showInComponentList": {
            "type": "boolean"
          },
          "xAbs": {
            "type": "string"
          },
          "yAbs": {
            "type": "string"
          }
        },
        "required": [
          "componentId",
          "shortName",
          "name",
          "group",
          "imageUrl",
          "genericArticleNos",
          "showInComponentList",
          "xAbs",
          "yAbs"
        ]
      },
      "CompartmentSystem": {
        "type": "object",
        "properties": {
          "systemId": {
            "type": "string"
          },
          "systemName": {
            "$ref": "#/components/schemas/Translation"
          },
          "dateFrom": {
            "type": "string"
          },
          "dateTo": {
            "type": "string"
          },
          "imagePlacementUrl": {
            "type": "string"
          },
          "components": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/CompartmentComponent"
            }
          }
        },
        "required": [
          "systemId",
          "systemName",
          "imagePlacementUrl",
          "components"
        ]
      },
      "Compartment": {
        "type": "object",
        "properties": {
          "systems": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/CompartmentSystem"
            }
          }
        },
        "required": [
          "systems"
        ]
      },
      "ComponentLocation": {
        "type": "object",
        "properties": {
          "vehicleReference": {
            "$ref": "#/components/schemas/VehicleReference"
          },
          "engineCompartment": {
            "$ref": "#/components/schemas/Compartment"
          }
        },
        "required": [
          "vehicleReference",
          "engineCompartment"
        ]
      },
      "ComponentGroup": {
        "type": "object",
        "properties": {
          "language": {
            "type": "string"
          },
          "title": {
            "type": "string"
          }
        },
        "required": [
          "language",
          "title"
        ]
      },
      "ComponentText": {
        "type": "object",
        "properties": {
          "language": {
            "type": "string"
          },
          "title": {
            "type": "string"
          }
        },
        "required": [
          "language",
          "title"
        ]
      },
      "DiagramComponent": {
        "type": "object",
        "properties": {
          "type": {
            "type": "string"
          },
          "id": {
            "type": "string"
          },
          "shortName": {
            "type": "string"
          },
          "showInComponentList": {
            "type": "boolean"
          },
          "genericArticleNumbers": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "group": {
            "$ref": "#/components/schemas/ComponentGroup"
          },
          "text": {
            "$ref": "#/components/schemas/ComponentText"
          }
        },
        "required": [
          "type",
          "id",
          "shortName",
          "showInComponentList",
          "genericArticleNumbers",
          "group",
          "text"
        ]
      },
      "ComponentCoordinate": {
        "type": "object",
        "properties": {
          "component": {
            "$ref": "#/components/schemas/DiagramComponent"
          },
          "x1": {
            "type": "number"
          },
          "y1": {
            "type": "number"
          },
          "x2": {
            "type": "number"
          },
          "y2": {
            "type": "number"
          }
        },
        "required": [
          "component",
          "x1",
          "y1",
          "x2",
          "y2"
        ]
      },
      "FuseBoxDocument": {
        "type": "object",
        "properties": {
          "title": {
            "type": "string"
          },
          "imageUrl": {
            "type": "string",
            "nullable": true,
            "default": null
          },
          "name": {
            "type": "string"
          },
          "componentCoordinates": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/ComponentCoordinate"
            }
          }
        },
        "required": [
          "title",
          "imageUrl",
          "name",
          "componentCoordinates"
        ]
      },
      "WiringDiagram": {
        "type": "object",
        "properties": {
          "title": {
            "type": "string"
          },
          "imageUrl": {
            "type": "string",
            "nullable": true
          },
          "componentCoordinates": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/ComponentCoordinate"
            }
          }
        },
        "required": [
          "title",
          "imageUrl",
          "componentCoordinates"
        ]
      },
      "ValueItem": {
        "type": "object",
        "properties": {
          "id": {
            "type": "string"
          },
          "value": {
            "type": "string"
          },
          "notes": {
            "type": "array",
            "items": {
              "type": "string"
            }
          },
          "imageUrls": {
            "type": "array",
            "items": {
              "type": "string"
            }
          }
        },
        "required": [
          "id",
          "value"
        ]
      },
      "StepItem": {
        "type": "object",
        "properties": {
          "order": {
            "type": "number"
          },
          "sequence": {
            "type": "string"
          },
          "text": {
            "type": "string"
          },
          "imageUrls": {
            "type": "array",
            "items": {
              "type": "string"
            }
          },
          "notes": {
            "type": "array",
            "items": {
              "type": "string"
            }
          }
        },
        "required": [
          "order",
          "text",
          "imageUrls"
        ]
      },
      "TechDataColumnHeader": {
        "type": "object",
        "properties": {
          "columnId": {
            "type": "string"
          },
          "columnNumber": {
            "type": "string"
          },
          "allowedDeviation": {
            "type": "string"
          }
        },
        "required": [
          "columnId",
          "columnNumber",
          "allowedDeviation"
        ]
      },
      "TechDataTableCell": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "columnNumber": {
            "type": "number"
          },
          "textValue": {
            "type": "string"
          }
        },
        "required": [
          "id",
          "columnNumber",
          "textValue"
        ]
      },
      "TechDataTableRow": {
        "type": "object",
        "properties": {
          "rowNumber": {
            "type": "number"
          },
          "cells": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/TechDataTableCell"
            }
          }
        },
        "required": [
          "rowNumber",
          "cells"
        ]
      },
      "TableData": {
        "type": "object",
        "properties": {
          "id": {
            "type": "string"
          },
          "columnHeaders": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/TechDataColumnHeader"
            }
          },
          "rows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/TechDataTableRow"
            }
          }
        },
        "required": [
          "id",
          "columnHeaders",
          "rows"
        ]
      },
      "GuideTranslation": {
        "type": "object",
        "properties": {
          "language": {
            "type": "string"
          },
          "title": {
            "type": "string"
          }
        },
        "required": [
          "language",
          "title"
        ]
      },
      "GuideTextReference": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "translations": {
            "$ref": "#/components/schemas/GuideTranslation"
          }
        },
        "required": [
          "id",
          "translations"
        ]
      },
      "GuideStepTitle": {
        "type": "object",
        "properties": {
          "textReference": {
            "$ref": "#/components/schemas/GuideTextReference"
          }
        },
        "required": [
          "textReference"
        ]
      },
      "GuideObjectReference": {
        "type": "object",
        "properties": {
          "type": {
            "type": "string"
          },
          "id": {
            "type": "string"
          }
        },
        "required": [
          "type",
          "id"
        ]
      },
      "GuideIcon": {
        "type": "object",
        "properties": {
          "order": {
            "type": "number"
          },
          "objectReference": {
            "$ref": "#/components/schemas/GuideObjectReference"
          },
          "fileExtension": {
            "type": "string"
          }
        },
        "required": [
          "order",
          "objectReference",
          "fileExtension"
        ]
      },
      "GuideLine": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "order": {
            "type": "number"
          },
          "textReference": {
            "$ref": "#/components/schemas/GuideTextReference"
          },
          "isListItem": {
            "type": "boolean"
          }
        },
        "required": [
          "id",
          "order",
          "textReference",
          "isListItem"
        ]
      },
      "GuideImage": {
        "type": "object",
        "properties": {
          "order": {
            "type": "number"
          },
          "objectReference": {
            "$ref": "#/components/schemas/GuideObjectReference"
          }
        },
        "required": [
          "order",
          "objectReference"
        ]
      },
      "GuideStep": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "type": {
            "type": "string"
          },
          "order": {
            "type": "number"
          },
          "title": {
            "$ref": "#/components/schemas/GuideStepTitle"
          },
          "icon": {
            "nullable": true,
            "allOf": [
              {
                "$ref": "#/components/schemas/GuideIcon"
              }
            ]
          },
          "lines": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/GuideLine"
            }
          },
          "images": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/GuideImage"
            }
          }
        },
        "required": [
          "id",
          "type",
          "order",
          "title",
          "icon",
          "lines",
          "images"
        ]
      },
      "Guide": {
        "type": "object",
        "properties": {
          "id": {
            "type": "string"
          },
          "title": {
            "type": "string",
            "nullable": true
          },
          "guideSteps": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/GuideStep"
            }
          }
        },
        "required": [
          "id",
          "title",
          "guideSteps"
        ]
      },
      "GenericArticleText": {
        "type": "object",
        "properties": {
          "language": {
            "type": "string"
          },
          "title": {
            "type": "string"
          }
        },
        "required": [
          "language",
          "title"
        ]
      },
      "GenericArticleInformation": {
        "type": "object",
        "properties": {
          "genArtNos": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "text": {
            "$ref": "#/components/schemas/GenericArticleText"
          },
          "defaultAmount": {
            "type": "number"
          }
        },
        "required": [
          "genArtNos",
          "text",
          "defaultAmount"
        ]
      },
      "TechDataItemData": {
        "type": "object",
        "properties": {
          "values": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/ValueItem"
            }
          },
          "steps": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/StepItem"
            }
          },
          "hasMultipleSequences": {
            "type": "boolean"
          },
          "sequences": {
            "type": "array",
            "items": {
              "type": "string"
            }
          },
          "table": {
            "$ref": "#/components/schemas/TableData"
          },
          "criteria": {
            "type": "object",
            "properties": {
              "id": {
                "type": "string"
              },
              "name": {
                "type": "string"
              }
            },
            "required": [
              "id",
              "name"
            ]
          },
          "variant": {
            "type": "object",
            "properties": {
              "id": {
                "type": "string"
              },
              "name": {
                "type": "string"
              }
            },
            "required": [
              "id",
              "name"
            ]
          },
          "guideIds": {
            "type": "array",
            "items": {
              "type": "string"
            }
          },
          "guides": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/Guide"
            }
          },
          "genericArticleInformation": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/GenericArticleInformation"
            }
          }
        }
      },
      "TechDataItem": {
        "type": "object",
        "properties": {
          "id": {
            "type": "string"
          },
          "groupId": {
            "type": "string"
          },
          "groupText": {
            "type": "string"
          },
          "groupPath": {
            "type": "array",
            "items": {
              "type": "string"
            }
          },
          "parentGroup": {
            "type": "object",
            "properties": {
              "id": {
                "type": "string"
              },
              "text": {
                "type": "string"
              }
            },
            "required": [
              "id",
              "text"
            ]
          },
          "type": {
            "type": "object"
          },
          "data": {
            "$ref": "#/components/schemas/TechDataItemData"
          },
          "markdown": {
            "type": "string"
          }
        },
        "required": [
          "id",
          "groupId",
          "groupText",
          "groupPath",
          "type",
          "data",
          "markdown"
        ]
      },
      "RecallItem": {
        "type": "object",
        "properties": {
          "headline": {
            "type": "string"
          },
          "text": {
            "type": "string"
          },
          "classification": {
            "type": "string"
          },
          "validFrom": {
            "type": "string"
          },
          "validTo": {
            "type": "string"
          },
          "kindOfVehicleTreeId": {
            "type": "string"
          }
        },
        "required": [
          "headline",
          "text",
          "classification",
          "validFrom",
          "validTo",
          "kindOfVehicleTreeId"
        ]
      },
      "RepairInstructionsDocument": {
        "type": "object",
        "properties": {
          "manualId": {
            "type": "number"
          },
          "title": {
            "type": "string"
          },
          "subtitle": {
            "type": "string"
          }
        },
        "required": [
          "manualId",
          "title",
          "subtitle"
        ]
      },
      "RepairTimesJob": {
        "type": "object",
        "properties": {
          "calcMode": {
            "type": "object"
          },
          "code": {
            "type": "string"
          },
          "name": {
            "type": "string"
          },
          "variantCode": {
            "type": "object"
          },
          "variantText": {
            "type": "string"
          },
          "genericArticleNo": {
            "type": "array",
            "items": {
              "type": "number"
            }
          }
        },
        "required": [
          "calcMode",
          "code",
          "name",
          "variantCode",
          "variantText",
          "genericArticleNo"
        ]
      },
      "RepairTimesAssociatedWork": {
        "type": "object",
        "properties": {
          "order": {
            "type": "number"
          },
          "display": {
            "type": "boolean"
          },
          "repairTime": {
            "type": "number"
          },
          "calculation": {
            "type": "object"
          },
          "job": {
            "$ref": "#/components/schemas/RepairTimesJob"
          }
        },
        "required": [
          "order",
          "display",
          "repairTime",
          "calculation",
          "job"
        ]
      },
      "RepairTimesLinkCriteria": {
        "type": "object",
        "properties": {
          "criteria": {
            "type": "string"
          },
          "criteriaValue": {
            "type": "string"
          }
        },
        "required": [
          "criteria",
          "criteriaValue"
        ]
      },
      "RepairTimesJobLinkDetails": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "hint": {
            "type": "string"
          },
          "order": {
            "type": "number"
          },
          "totalRepairTime": {
            "type": "number"
          },
          "associatedWorks": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/RepairTimesAssociatedWork"
            }
          },
          "linkCriteria": {
            "$ref": "#/components/schemas/RepairTimesLinkCriteria"
          }
        },
        "required": [
          "id",
          "hint",
          "order",
          "totalRepairTime",
          "associatedWorks",
          "linkCriteria"
        ]
      },
      "RepairTimesJobLinkOther": {
        "type": "object",
        "properties": {
          "order": {
            "type": "number"
          },
          "link": {
            "$ref": "#/components/schemas/RepairTimesJobLinkDetails"
          }
        },
        "required": [
          "order",
          "link"
        ]
      },
      "RepairTimesJobLink": {
        "type": "object",
        "properties": {
          "jobLink": {
            "$ref": "#/components/schemas/RepairTimesJobLinkDetails"
          },
          "preliminaryLinks": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/RepairTimesJobLinkOther"
            }
          },
          "subsequentLinks": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/RepairTimesJobLinkOther"
            }
          },
          "notIncludedLinks": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/RepairTimesJobLinkOther"
            }
          }
        },
        "required": [
          "jobLink",
          "preliminaryLinks",
          "subsequentLinks",
          "notIncludedLinks"
        ]
      },
      "RepairTime": {
        "type": "object",
        "properties": {
          "category": {
            "type": "string"
          },
          "subCategory": {
            "type": "string"
          },
          "code": {
            "type": "string"
          },
          "id": {
            "type": "number"
          },
          "variantCode": {
            "type": "object"
          },
          "variantText": {
            "type": "string"
          },
          "name": {
            "type": "string"
          },
          "genericArticleNo": {
            "type": "array",
            "items": {
              "type": "number"
            }
          },
          "calcMode": {
            "type": "object"
          },
          "jobLinks": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/RepairTimesJobLink"
            }
          }
        },
        "required": [
          "category",
          "subCategory",
          "code",
          "id",
          "variantCode",
          "variantText",
          "name",
          "genericArticleNo",
          "calcMode",
          "jobLinks"
        ]
      },
      "RepairTimesDetails": {
        "type": "object",
        "properties": {
          "category": {
            "type": "string"
          },
          "subCategory": {
            "type": "string"
          },
          "repairTimes": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/RepairTime"
            }
          }
        },
        "required": [
          "category",
          "subCategory",
          "repairTimes"
        ]
      },
      "DocumentParameters": {
        "type": "object",
        "properties": {
          "type": {
            "type": "string"
          },
          "carTypeId": {
            "type": "number"
          },
          "carTypeGroup": {
            "enum": [
              "ENGINE",
              "TRANSMISSION",
              "STEERING",
              "BRAKES",
              "EXTERIOR",
              "ELECTRONICS",
              "QUICKGUIDES"
            ],
            "type": "string"
          },
          "location": {
            "enum": [
              5,
              4,
              1,
              2,
              3,
              6
            ],
            "type": "number"
          },
          "storyId": {
            "type": "number"
          },
          "tsbType": {
            "type": "string"
          },
          "systemId": {
            "type": "number"
          },
          "errorCode": {
            "type": "string"
          },
          "vin": {
            "type": "string"
          },
          "engineCode": {
            "type": "string"
          },
          "mbId": {
            "type": "number"
          },
          "mbNumber": {
            "type": "string"
          },
          "mbInfoTypeCode": {
            "type": "number"
          },
          "daily": {
            "type": "boolean"
          },
          "managementSystemId": {
            "type": "number"
          },
          "componentId": {
            "type": "number"
          },
          "systemName": {
            "type": "string"
          },
          "componentName": {
            "type": "string"
          },
          "level": {
            "type": "object"
          },
          "systemGroupId": {
            "type": "number"
          },
          "systemGroupName": {
            "type": "string"
          },
          "systems": {
            "type": "array",
            "items": {
              "type": "object"
            }
          },
          "components": {
            "type": "array",
            "items": {
              "type": "object"
            }
          },
          "chapterId": {
            "type": "string"
          },
          "mainChapterId": {
            "type": "string"
          },
          "xmlDocumentId": {
            "type": "string"
          },
          "repairGroupNumber": {
            "type": "string"
          },
          "elasticsearchId": {
            "type": "string"
          },
          "wdGroupNumber": {
            "type": "string"
          },
          "guid": {
            "type": "string"
          },
          "hgsDocumentId": {
            "type": "string"
          },
          "documentText": {
            "type": "string"
          },
          "hgsSystemId": {
            "type": "string"
          },
          "language": {
            "type": "string"
          },
          "docTitle": {
            "type": "string"
          },
          "kType": {
            "type": "string"
          },
          "hgsComponentId": {
            "type": "string"
          },
          "techDataGroupId": {
            "type": "string"
          },
          "recallHeadline": {
            "type": "string"
          },
          "country": {
            "type": "string"
          },
          "hgsServiceScheduleId": {
            "type": "number"
          },
          "parentGroupId": {
            "type": "string"
          },
          "parentGroupText": {
            "type": "string"
          },
          "grandParentGroupId": {
            "type": "string"
          },
          "grandParentGroupText": {
            "type": "string"
          },
          "mainGroupId": {
            "type": "string"
          },
          "subGroupId": {
            "type": "string"
          },
          "manualGroupId": {
            "type": "string"
          },
          "manualId": {
            "type": "string"
          },
          "qualifierId": {
            "type": "string"
          },
          "categoryId": {
            "type": "string"
          },
          "subCategoryId": {
            "type": "string"
          },
          "genericArticleNo": {
            "type": "string"
          },
          "searchTerm": {
            "type": "string"
          }
        },
        "required": [
          "type"
        ]
      },
      "SearchEntry": {
        "type": "object",
        "properties": {
          "text": {
            "type": "string"
          },
          "previewText": {
            "type": "string"
          },
          "tags": {
            "type": "array",
            "items": {
              "type": "string"
            }
          },
          "provider": {
            "enum": [
              "static",
              "haynespro",
              "mercedes",
              "volkswagen",
              "skoda",
              "seat",
              "audi",
              "tesla",
              "hgs",
              "qiradb",
              "varta"
            ],
            "type": "string"
          },
          "subject": {
            "enum": [
              "Lubricants",
              "Adjustments",
              "MaintenancePeriods",
              "MaintenanceProcesses",
              "MaintenanceForms",
              "MaintenanceServiceResets",
              "EOBDLocations",
              "FuseLocations",
              "EngineLocations",
              "Locations",
              "ControlUnitLocations",
              "GroundingPointLocations",
              "HVACLocations",
              "RepairManuals",
              "WarningLights",
              "TechnicalDrawings",
              "TechData",
              "SmartCases",
              "Recalls",
              "Bulletins",
              "ErrorCode",
              "WiringDiagrams",
              "FuseBoxes",
              "RepairInstructions",
              "RepairTimes",
              "Battery",
              "Default"
            ],
            "type": "string"
          },
          "parameters": {
            "$ref": "#/components/schemas/DocumentParameters"
          },
          "id": {
            "type": "string"
          }
        },
        "required": [
          "text",
          "tags",
          "provider",
          "subject",
          "parameters",
          "id"
        ]
      },
      "InspectionItemInfo": {
        "type": "object",
        "properties": {
          "name": {
            "type": "string"
          },
          "operation": {
            "type": "string"
          },
          "aggregatedLabourTime": {
            "type": "number"
          }
        },
        "required": [
          "name",
          "operation",
          "aggregatedLabourTime"
        ]
      },
      "InspectionInfo": {
        "type": "object",
        "properties": {
          "name": {
            "type": "string"
          },
          "icon": {
            "type": "string"
          },
          "items": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/InspectionItemInfo"
            }
          }
        },
        "required": [
          "name",
          "icon",
          "items"
        ]
      },
      "InspectionDocument": {
        "type": "object",
        "properties": {
          "title": {
            "type": "string"
          },
          "inspections": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/InspectionInfo"
            }
          },
          "components": {
            "type": "array",
            "items": {
              "type": "string"
            }
          }
        },
        "required": [
          "title",
          "inspections",
          "components"
        ]
      },
      "HgsData": {
        "type": "object",
        "properties": {
          "componentLocation": {
            "$ref": "#/components/schemas/ComponentLocation"
          },
          "fuseBoxDocument": {
            "$ref": "#/components/schemas/FuseBoxDocument"
          },
          "wiringDiagram": {
            "$ref": "#/components/schemas/WiringDiagram"
          },
          "techDataItem": {
            "$ref": "#/components/schemas/TechDataItem"
          },
          "recallItem": {
            "$ref": "#/components/schemas/RecallItem"
          },
          "repairInstructions": {
            "$ref": "#/components/schemas/RepairInstructionsDocument"
          },
          "repairTimesDetails": {
            "$ref": "#/components/schemas/RepairTimesDetails"
          },
          "serviceSchedules": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/SearchEntry"
            }
          },
          "inspectionDocument": {
            "$ref": "#/components/schemas/InspectionDocument"
          }
        }
      },
      "HgsArticle": {
        "type": "object",
        "properties": {
          "text": {
            "type": "string"
          },
          "data": {
            "$ref": "#/components/schemas/HgsData"
          }
        },
        "required": [
          "text"
        ]
      },
      "Manufacturer": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "name": {
            "type": "string"
          }
        },
        "required": [
          "id",
          "name"
        ]
      },
      "ModelDetails": {
        "type": "object",
        "properties": {
          "yearOfConstrFrom": {
            "type": "number"
          },
          "yearOfConstrTo": {
            "type": "number"
          }
        }
      },
      "Model": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number"
          },
          "name": {
            "type": "string"
          },
          "details": {
            "$ref": "#/components/schemas/ModelDetails"
          },
          "displayString": {
            "type": "string"
          }
        },
        "required": [
          "id",
          "name",
          "details"
        ]
      },
      "VehicleIdentifier": {
        "type": "object",
        "properties": {
          "carTypeId": {
            "type": "number"
          },
          "kTypeIdTecDoc": {
            "type": "number",
            "nullable": true
          }
        }
      },
      "Vehicle": {
        "type": "object",
        "properties": {
          "id": {
            "$ref": "#/components/schemas/VehicleIdentifier"
          },
          "name": {
            "type": "string"
          },
          "madeFrom": {
            "type": "string",
            "nullable": true
          },
          "madeUntil": {
            "type": "string",
            "nullable": true
          },
          "engineCode": {
            "type": "string",
            "nullable": true
          },
          "fuelType": {
            "nullable": true,
            "type": "array",
            "items": {
              "type": "string"
            }
          },
          "capacity": {
            "type": "number",
            "nullable": true
          },
          "output": {
            "type": "number",
            "nullable": true
          },
          "tonnage": {
            "type": "number",
            "nullable": true
          },
          "image": {
            "type": "string",
            "nullable": true
          },
          "subjectsByGroup": {
            "type": "object",
            "properties": {
              "mapItems": {
                "type": "array",
                "items": {
                  "type": "object"
                }
              }
            },
            "required": [
              "mapItems"
            ]
          },
          "tecDocPrototypes": {
            "type": "array",
            "items": {
              "type": "string"
            }
          }
        },
        "required": [
          "id",
          "name"
        ]
      },
      "HpWSCriteriaValue": {
        "type": "object",
        "properties": {
          "id": {
            "type": "string",
            "nullable": true
          },
          "value": {
            "type": "string",
            "nullable": true
          }
        },
        "required": [
          "id",
          "value"
        ]
      },
      "HpWSCriteria": {
        "type": "object",
        "properties": {
          "dataType": {
            "type": "string",
            "nullable": true
          },
          "description": {
            "type": "string",
            "nullable": true
          },
          "id": {
            "type": "string",
            "nullable": true
          },
          "values": {
            "nullable": true,
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/HpWSCriteriaValue"
            }
          }
        },
        "required": [
          "dataType",
          "description",
          "id",
          "values"
        ]
      },
      "HpStatus": {
        "type": "object",
        "properties": {
          "statusCode": {
            "type": "number"
          },
          "confirmationLink": {
            "type": "string",
            "nullable": true
          }
        },
        "required": [
          "statusCode",
          "confirmationLink"
        ]
      },
      "HpWSIdentificationElement": {
        "type": "object",
        "properties": {
          "id": {
            "type": "number",
            "nullable": true
          },
          "level": {
            "type": "object",
            "nullable": true
          },
          "order": {
            "type": "number",
            "nullable": true
          },
          "name": {
            "type": "string",
            "nullable": true
          },
          "fullName": {
            "type": "string",
            "nullable": true
          },
          "madeFrom": {
            "type": "string",
            "nullable": true
          },
          "madeUntil": {
            "type": "string",
            "nullable": true
          },
          "engineCode": {
            "type": "string",
            "nullable": true
          },
          "fuelType": {
            "nullable": true,
            "type": "array",
            "items": {
              "type": "object"
            }
          },
          "capacity": {
            "type": "number",
            "nullable": true
          },
          "output": {
            "type": "number",
            "nullable": true
          },
          "tonnage": {
            "type": "number",
            "nullable": true
          },
          "image": {
            "type": "string",
            "nullable": true
          },
          "superElementId": {
            "type": "number",
            "nullable": true
          },
          "superElementLevel": {
            "type": "object"
          },
          "subjects": {
            "nullable": true,
            "type": "array",
            "items": {
              "type": "object"
            }
          },
          "subjectsByGroup": {
            "type": "object",
            "properties": {
              "mapItems": {
                "type": "array",
                "items": {
                  "type": "object"
                }
              }
            },
            "required": [
              "mapItems"
            ]
          },
          "criteria": {
            "nullable": true,
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/HpWSCriteria"
            }
          },
          "subElements": {
            "nullable": true,
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/HpWSIdentificationElement"
            }
          },
          "status": {
            "nullable": true,
            "allOf": [
              {
                "$ref": "#/components/schemas/HpStatus"
              }
            ]
          }
        },
        "required": [
          "id",
          "level",
          "order",
          "name",
          "fullName",
          "madeFrom",
          "madeUntil",
          "engineCode",
          "fuelType",
          "capacity",
          "output",
          "tonnage",
          "image",
          "superElementId",
          "superElementLevel",
          "subjects",
          "subjectsByGroup",
          "criteria",
          "subElements",
          "status"
        ]
      },
      "CatalogueIdentification": {
        "type": "object",
        "properties": {
          "make": {
            "$ref": "#/components/schemas/Manufacturer"
          },
          "model": {
            "$ref": "#/components/schemas/Model"
          }
        },
        "required": [
          "make",
          "model"
        ]
      },
      "VehicleIdentification": {
        "type": "object",
        "properties": {
          "vin": {
            "type": "string"
          },
          "kba": {
            "type": "string"
          },
          "catalogue": {
            "$ref": "#/components/schemas/CatalogueIdentification"
          },
          "engineCode": {
            "type": "string"
          },
          "id": {
            "$ref": "#/components/schemas/VehicleIdentifier"
          }
        },
        "required": [
          "id"
        ]
      },
      "CreateThreadDto": {
        "type": "object",
        "properties": {
          "title": {
            "type": "string"
          },
          "vehicleIdentification": {
            "$ref": "#/components/schemas/VehicleIdentification"
          },
          "testing": {
            "type": "boolean"
          }
        },
        "required": [
          "title",
          "vehicleIdentification"
        ]
      },
      "ComponentData": {
        "type": "object",
        "properties": {
          "systemId": {
            "type": "string"
          },
          "systemName": {
            "type": "string"
          },
          "componentId": {
            "type": "string"
          },
          "componentName": {
            "type": "string"
          }
        },
        "required": [
          "systemId",
          "systemName",
          "componentId",
          "componentName"
        ]
      },
      "SystemGroupData": {
        "type": "object",
        "properties": {
          "systemGroupId": {
            "type": "number"
          },
          "systemGroupName": {
            "type": "string"
          },
          "componentData": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/ComponentData"
            }
          }
        },
        "required": [
          "systemGroupName",
          "componentData"
        ]
      },
      "ChatWidgetParameters": {
        "type": "object",
        "properties": {
          "carTypeId": {
            "type": "number"
          },
          "errorCode": {
            "type": "string"
          },
          "mode": {
            "type": "string"
          },
          "systemGroups": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/SystemGroupData"
            }
          },
          "components": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/ComponentData"
            }
          }
        }
      },
      "ChatWidget": {
        "type": "object",
        "properties": {
          "id": {
            "type": "string",
            "enum": [
              "component-wiring-diagram",
              "guided-diagnosis"
            ]
          },
          "name": {
            "type": "string"
          },
          "endpoint": {
            "type": "string"
          },
          "parameters": {
            "$ref": "#/components/schemas/ChatWidgetParameters"
          }
        },
        "required": [
          "id"
        ]
      },
      "SourceDetails": {
        "type": "object",
        "properties": {
          "documentParameters": {
            "$ref": "#/components/schemas/DocumentParameters"
          },
          "errorCode": {
            "type": "string"
          },
          "originalURL": {
            "type": "string"
          }
        }
      },
      "Source": {
        "type": "object",
        "properties": {
          "provider": {
            "enum": [
              "static",
              "haynespro",
              "mercedes",
              "volkswagen",
              "skoda",
              "seat",
              "audi",
              "tesla",
              "hgs",
              "qiradb",
              "varta"
            ],
            "type": "string"
          },
          "subject": {
            "enum": [
              "Lubricants",
              "Adjustments",
              "MaintenancePeriods",
              "MaintenanceProcesses",
              "MaintenanceForms",
              "MaintenanceServiceResets",
              "EOBDLocations",
              "FuseLocations",
              "EngineLocations",
              "Locations",
              "ControlUnitLocations",
              "GroundingPointLocations",
              "HVACLocations",
              "RepairManuals",
              "WarningLights",
              "TechnicalDrawings",
              "TechData",
              "SmartCases",
              "Recalls",
              "Bulletins",
              "ErrorCode",
              "WiringDiagrams",
              "FuseBoxes",
              "RepairInstructions",
              "RepairTimes",
              "Battery",
              "Default"
            ],
            "type": "string"
          },
          "title": {
            "type": "string"
          },
          "details": {
            "$ref": "#/components/schemas/SourceDetails"
          }
        },
        "required": [
          "provider",
          "subject",
          "details"
        ]
      },
      "QiraMessageContentChunk": {
        "type": "object",
        "properties": {
          "provider": {
            "type": "string",
            "enum": [
              "static",
              "haynespro",
              "mercedes",
              "volkswagen",
              "skoda",
              "seat",
              "audi",
              "tesla",
              "hgs",
              "qiradb",
              "varta"
            ]
          },
          "text": {
            "type": "string"
          },
          "answerType": {
            "type": "object"
          },
          "document": {
            "type": "object",
            "properties": {
              "previewText": {
                "type": "string"
              },
              "parameters": {
                "$ref": "#/components/schemas/DocumentParameters"
              },
              "subject": {
                "enum": [
                  "Lubricants",
                  "Adjustments",
                  "MaintenancePeriods",
                  "MaintenanceProcesses",
                  "MaintenanceForms",
                  "MaintenanceServiceResets",
                  "EOBDLocations",
                  "FuseLocations",
                  "EngineLocations",
                  "Locations",
                  "ControlUnitLocations",
                  "GroundingPointLocations",
                  "HVACLocations",
                  "RepairManuals",
                  "WarningLights",
                  "TechnicalDrawings",
                  "TechData",
                  "SmartCases",
                  "Recalls",
                  "Bulletins",
                  "ErrorCode",
                  "WiringDiagrams",
                  "FuseBoxes",
                  "RepairInstructions",
                  "RepairTimes",
                  "Battery",
                  "Default"
                ],
                "type": "string"
              },
              "id": {
                "type": "string"
              },
              "data": {
                "type": "object"
              },
              "cited": {
                "type": "boolean"
              }
            },
            "required": [
              "previewText",
              "parameters",
              "subject",
              "id"
            ]
          },
          "widget": {
            "$ref": "#/components/schemas/ChatWidget"
          },
          "sources": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/Source"
            }
          },
          "errorDocument": {
            "type": "object",
            "properties": {
              "errorCode": {
                "type": "string"
              },
              "description": {
                "type": "string"
              }
            },
            "required": [
              "errorCode",
              "description"
            ]
          },
          "intentSuggestions": {
            "type": "array",
            "items": {
              "type": "string"
            }
          }
        },
        "required": [
          "provider"
        ]
      },
      "QiraMessage": {
        "type": "object",
        "properties": {
          "id": {
            "type": "string"
          },
          "created_at": {
            "format": "date-time",
            "type": "string"
          },
          "sender": {
            "enum": [
              "bot",
              "you"
            ],
            "type": "string"
          },
          "type": {
            "enum": [
              "end",
              "info",
              "error",
              "stream",
              "feedback"
            ],
            "type": "string"
          },
          "voting": {
            "type": "number"
          },
          "feedback": {
            "type": "string"
          },
          "content": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/QiraMessageContentChunk"
            }
          },
          "toolUsage": {
            "type": "array",
            "items": {
              "type": "object"
            }
          }
        },
        "required": [
          "id",
          "created_at",
          "sender",
          "type",
          "content"
        ]
      },
      "ThreadSession": {
        "type": "object",
        "properties": {
          "vehicle": {
            "$ref": "#/components/schemas/Vehicle"
          }
        }
      },
      "Thread": {
        "type": "object",
        "properties": {
          "_id": {
            "type": "string"
          },
          "created_at": {
            "format": "date-time",
            "type": "string"
          },
          "last_updated_at": {
            "format": "date-time",
            "type": "string"
          },
          "vehicleIdentification": {
            "$ref": "#/components/schemas/VehicleIdentification"
          },
          "userId": {
            "type": "string"
          },
          "title": {
            "type": "string"
          },
          "messages": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/QiraMessage"
            }
          },
          "session": {
            "$ref": "#/components/schemas/ThreadSession"
          },
          "repairTimesSearchEntries": {
            "type": "string"
          }
        },
        "required": [
          "_id",
          "created_at",
          "last_updated_at",
          "vehicleIdentification",
          "userId",
          "title",
          "messages",
          "session"
        ]
      },
      "ThreadWithoutMessagesDto": {
        "type": "object",
        "properties": {
          "_id": {
            "type": "string"
          },
          "created_at": {
            "format": "date-time",
            "type": "string"
          },
          "last_updated_at": {
            "format": "date-time",
            "type": "string"
          },
          "vehicleIdentification": {
            "$ref": "#/components/schemas/VehicleIdentification"
          },
          "userId": {
            "type": "string"
          },
          "title": {
            "type": "string"
          },
          "session": {
            "$ref": "#/components/schemas/ThreadSession"
          }
        },
        "required": [
          "_id",
          "created_at",
          "last_updated_at",
          "vehicleIdentification",
          "userId",
          "title",
          "session"
        ]
      },
      "UpdateThreadDto": {
        "type": "object",
        "properties": {
          "title": {
            "type": "string"
          },
          "vehicleIdentification": {
            "$ref": "#/components/schemas/VehicleIdentification"
          },
          "testing": {
            "type": "boolean"
          }
        }
      },
      "CreateMessageDto": {
        "type": "object",
        "properties": {
          "text": {
            "type": "string"
          },
          "qiraSystem": {
            "type": "object"
          }
        },
        "required": [
          "text",
          "qiraSystem"
        ]
      },
      "UpdateMessageDto": {
        "type": "object",
        "properties": {
          "voting": {
            "type": "number",
            "nullable": true
          },
          "feedback": {
            "type": "string",
            "nullable": true
          }
        }
      },
      "NavigationItem": {
        "type": "object",
        "properties": {
          "name": {
            "type": "string",
            "nullable": true
          },
          "id": {
            "type": "number",
            "nullable": true
          },
          "items": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/NavigationItem"
            }
          },
          "details": {
            "type": "string"
          }
        },
        "required": [
          "name",
          "id"
        ]
      },
      "QiraEventKind": {
        "type": "number",
        "enum": [
          320000,
          500000,
          600000,
          600001,
          600002,
          700000,
          100000,
          300000,
          300100,
          300200,
          300210,
          300220,
          340000,
          300300,
          330000,
          310000,
          310010,
          210000,
          211000,
          212000,
          212010,
          220000,
          400100,
          400200,
          410000
        ]
      },
      "EventPayload": {
        "type": "object",
        "properties": {
          "thread_id": {
            "type": "string"
          },
          "url": {
            "type": "string"
          },
          "question_text": {
            "type": "string"
          },
          "created_at": {
            "type": "string"
          },
          "updated_at": {
            "type": "string"
          },
          "answer_text": {
            "type": "string"
          },
          "answer_id": {
            "type": "string"
          },
          "sources": {
            "type": "array",
            "items": {
              "type": "string"
            }
          },
          "generation_time_ms": {
            "type": "number"
          },
          "vote": {
            "type": "number"
          },
          "vehicle_brand": {
            "type": "string"
          },
          "trigger_type": {
            "type": "string"
          },
          "feedback_text": {
            "type": "string"
          },
          "car_type_id": {
            "type": "number"
          },
          "k_type_id": {
            "type": "number"
          },
          "vin": {
            "type": "string"
          },
          "kba": {
            "type": "string"
          },
          "manual": {
            "type": "boolean"
          },
          "hp_make_id": {
            "type": "number"
          },
          "hp_model_id": {
            "type": "number"
          },
          "deleted_at": {
            "format": "date-time",
            "type": "string"
          },
          "code_id": {
            "type": "string"
          },
          "code_redeemed": {
            "type": "boolean"
          },
          "cancelled_date": {
            "type": "string"
          },
          "cancellation_reversal_date": {
            "type": "string"
          },
          "last_logout_at": {
            "type": "string"
          },
          "account_deleted_at": {
            "type": "string"
          },
          "content_filter_triggered": {
            "type": "boolean"
          },
          "answer_found_to_question": {
            "type": "boolean"
          },
          "qira_system": {
            "type": "object"
          }
        }
      },
      "EventData": {
        "type": "object",
        "properties": {
          "kind": {
            "allOf": [
              {
                "$ref": "#/components/schemas/QiraEventKind"
              }
            ]
          },
          "event_source": {
            "type": "string"
          },
          "environment": {
            "type": "string"
          },
          "company_id": {
            "type": "string"
          },
          "user_id": {
            "type": "string"
          },
          "payload": {
            "$ref": "#/components/schemas/EventPayload"
          }
        },
        "required": [
          "kind",
          "payload"
        ]
      },
      "QiraEventLegacy": {
        "type": "object",
        "properties": {
          "event": {
            "$ref": "#/components/schemas/EventData"
          }
        },
        "required": [
          "event"
        ]
      },
      "QiraEvent": {
        "type": "object",
        "properties": {
          "eventCode": {
            "type": "object"
          },
          "userId": {
            "type": "string"
          },
          "payload": {
            "type": "object"
          }
        },
        "required": [
          "eventCode",
          "payload"
        ]
      },
      "HpArticle": {
        "type": "object",
        "properties": {
          "text": {
            "type": "string"
          }
        },
        "required": [
          "text"
        ]
      },
      "SuccessResponseDto": {
        "type": "object",
        "properties": {
          "success": {
            "type": "boolean",
            "description": "Indicates if the operation was successful",
            "example": true
          }
        },
        "required": [
          "success"
        ]
      },
      "EnhancedProductDto": {
        "type": "object",
        "properties": {
          "productPrices": {
            "description": "extends Stripe Product",
            "type": "array",
            "items": {
              "type": "string"
            }
          }
        },
        "required": [
          "productPrices"
        ]
      },
      "HpPoint": {
        "type": "object",
        "properties": {
          "xvalue": {
            "type": "number"
          },
          "yminvalue": {
            "type": "number"
          },
          "ymaxvalue": {
            "type": "number"
          }
        },
        "required": [
          "xvalue",
          "yminvalue",
          "ymaxvalue"
        ]
      },
      "HpGraph": {
        "type": "object",
        "properties": {
          "xaxis": {
            "type": "string",
            "nullable": true
          },
          "yaxis": {
            "type": "string",
            "nullable": true
          },
          "points": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/HpPoint"
            }
          }
        },
        "required": [
          "xaxis",
          "yaxis",
          "points"
        ]
      },
      "HpRow": {
        "type": "object",
        "properties": {
          "value1": {
            "type": "string",
            "nullable": true
          },
          "value2": {
            "type": "string",
            "nullable": true
          }
        },
        "required": [
          "value1",
          "value2"
        ]
      },
      "HpTable": {
        "type": "object",
        "properties": {
          "header": {
            "nullable": true,
            "allOf": [
              {
                "$ref": "#/components/schemas/HpRow"
              }
            ]
          },
          "rows": {
            "nullable": true,
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/HpRow"
            }
          }
        },
        "required": [
          "header",
          "rows"
        ]
      },
      "HpDiagramToolParameters": {
        "type": "object",
        "properties": {}
      },
      "HpDiagnosisStepV3": {
        "type": "object",
        "properties": {
          "flashVarsString": {
            "type": "string",
            "nullable": true
          },
          "graph": {
            "nullable": true,
            "allOf": [
              {
                "$ref": "#/components/schemas/HpGraph"
              }
            ]
          },
          "name": {
            "type": "string",
            "nullable": true
          },
          "noAnswer": {
            "nullable": true,
            "allOf": [
              {
                "$ref": "#/components/schemas/HpDiagnosisStepV3"
              }
            ]
          },
          "scopeImagesPaths": {
            "nullable": true,
            "type": "array",
            "items": {
              "type": "string"
            }
          },
          "sortOrder": {
            "type": "number",
            "nullable": true
          },
          "table": {
            "nullable": true,
            "allOf": [
              {
                "$ref": "#/components/schemas/HpTable"
              }
            ]
          },
          "text": {
            "type": "string",
            "nullable": true
          },
          "title": {
            "type": "string",
            "nullable": true
          },
          "toolParameters": {
            "nullable": true,
            "allOf": [
              {
                "$ref": "#/components/schemas/HpDiagramToolParameters"
              }
            ]
          },
          "type": {
            "type": "object"
          },
          "wirediagramLink": {
            "type": "string",
            "nullable": true
          },
          "yesAnswer": {
            "nullable": true,
            "allOf": [
              {
                "$ref": "#/components/schemas/HpDiagnosisStepV3"
              }
            ]
          }
        },
        "required": [
          "flashVarsString",
          "graph",
          "name",
          "noAnswer",
          "scopeImagesPaths",
          "sortOrder",
          "table",
          "text",
          "title",
          "toolParameters",
          "type",
          "wirediagramLink",
          "yesAnswer"
        ]
      },
      "HpWizardV3": {
        "type": "object",
        "properties": {
          "diagnosisSteps": {
            "nullable": true,
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/HpDiagnosisStepV3"
            }
          },
          "title": {
            "type": "string",
            "nullable": true
          }
        },
        "required": [
          "diagnosisSteps",
          "title"
        ]
      },
      "HpGenericPart": {
        "type": "object",
        "properties": {}
      },
      "HpLinkedStoriesV2": {
        "type": "object",
        "properties": {}
      },
      "HpComponentWsV2": {
        "type": "object",
        "properties": {
          "name": {
            "type": "string",
            "nullable": true
          },
          "description": {
            "type": "string",
            "nullable": true
          },
          "pinName": {
            "type": "string",
            "nullable": true
          },
          "wireColor1": {
            "type": "string",
            "nullable": true
          },
          "wireColor2": {
            "type": "string",
            "nullable": true
          },
          "hyperlink": {
            "type": "boolean",
            "nullable": true
          },
          "si": {
            "type": "number",
            "nullable": true
          },
          "st": {
            "type": "number",
            "nullable": true
          },
          "pinNumber": {
            "type": "string",
            "nullable": true
          },
          "supplied": {
            "type": "boolean",
            "nullable": true
          },
          "voltage": {
            "type": "string",
            "nullable": true
          }
        },
        "required": [
          "name",
          "description",
          "pinName",
          "wireColor1",
          "wireColor2",
          "hyperlink",
          "si",
          "st",
          "pinNumber",
          "supplied",
          "voltage"
        ]
      },
      "HpPinsArrayV2": {
        "type": "object",
        "properties": {
          "componentsArray": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/HpComponentWsV2"
            }
          }
        },
        "required": [
          "componentsArray"
        ]
      },
      "HpSmartLink": {
        "type": "object",
        "properties": {
          "operation": {
            "type": "string",
            "nullable": true
          },
          "text": {
            "nullable": true,
            "type": "array",
            "items": {
              "type": "object"
            }
          },
          "id1": {
            "type": "number"
          },
          "id2": {
            "type": "string",
            "nullable": true
          },
          "filter": {
            "type": "string",
            "nullable": true
          }
        },
        "required": [
          "operation",
          "text",
          "id1",
          "id2",
          "filter"
        ]
      },
      "HpCompleteComponentV10": {
        "type": "object",
        "properties": {
          "componentCode": {
            "type": "string",
            "nullable": true
          },
          "componentDescription": {
            "type": "string",
            "nullable": true
          },
          "componentImageId": {
            "type": "number",
            "nullable": true
          },
          "connectorSideImage": {
            "type": "string",
            "nullable": true
          },
          "diagnosisSteps": {
            "nullable": true,
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/HpWizardV3"
            }
          },
          "ecuSideImage": {
            "type": "string",
            "nullable": true
          },
          "genericParts": {
            "nullable": true,
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/HpGenericPart"
            }
          },
          "hasLocationSystems": {
            "type": "boolean",
            "nullable": true
          },
          "linkedStories": {
            "nullable": true,
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/HpLinkedStoriesV2"
            }
          },
          "localWiringImageConcise": {
            "type": "string",
            "nullable": true
          },
          "localWiringImageExtended": {
            "type": "string",
            "nullable": true
          },
          "pinTable": {
            "nullable": true,
            "allOf": [
              {
                "$ref": "#/components/schemas/HpPinsArrayV2"
              }
            ]
          },
          "pinTableExtended": {
            "nullable": true,
            "allOf": [
              {
                "$ref": "#/components/schemas/HpPinsArrayV2"
              }
            ]
          },
          "renderable": {
            "type": "boolean",
            "nullable": true
          },
          "smartLinks": {
            "nullable": true,
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/HpSmartLink"
            }
          },
          "symbolInstance": {
            "type": "string",
            "nullable": true
          }
        },
        "required": [
          "componentCode",
          "componentDescription",
          "componentImageId",
          "connectorSideImage",
          "diagnosisSteps",
          "ecuSideImage",
          "genericParts",
          "hasLocationSystems",
          "linkedStories",
          "localWiringImageConcise",
          "localWiringImageExtended",
          "pinTable",
          "pinTableExtended",
          "renderable",
          "smartLinks",
          "symbolInstance"
        ]
      },
      "CompleteComponentListItem": {
        "type": "object",
        "properties": {
          "component": {
            "$ref": "#/components/schemas/HpCompleteComponentV10"
          },
          "title": {
            "type": "string"
          }
        },
        "required": [
          "component",
          "title"
        ]
      },
      "AffectedDiagnostic": {
        "type": "object",
        "properties": {
          "completeComponentList": {
            "description": "List of complete components",
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/CompleteComponentListItem"
            }
          },
          "text": {
            "type": "string"
          }
        },
        "required": [
          "completeComponentList",
          "text"
        ]
      },
      "HpVesaSystem": {
        "type": "object",
        "properties": {
          "system_type_id": {
            "type": "number"
          },
          "text": {
            "type": "string",
            "nullable": true
          }
        },
        "required": [
          "system_type_id",
          "text"
        ]
      },
      "HpSystemGroup": {
        "type": "object",
        "properties": {
          "sg_number": {
            "type": "number",
            "nullable": true
          },
          "system_group_id": {
            "type": "number",
            "nullable": true
          },
          "systems": {
            "nullable": true,
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/HpVesaSystem"
            }
          },
          "text": {
            "type": "string",
            "nullable": true
          }
        },
        "required": [
          "sg_number",
          "system_group_id",
          "systems",
          "text"
        ]
      },
      "VariantGroup": {
        "type": "object",
        "properties": {
          "mainGroup": {
            "type": "string",
            "nullable": true
          },
          "systemGroups": {
            "nullable": true,
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/HpSystemGroup"
            }
          },
          "system_group_id": {
            "type": "number"
          },
          "system_group_number": {
            "type": "number",
            "nullable": true
          },
          "systems": {
            "nullable": true,
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/HpVesaSystem"
            }
          },
          "text": {
            "type": "string",
            "nullable": true
          }
        },
        "required": [
          "mainGroup",
          "systemGroups",
          "system_group_id",
          "system_group_number",
          "systems",
          "text"
        ]
      },
      "HpGeneralArticle": {
        "type": "object",
        "properties": {
          "description": {
            "type": "string",
            "nullable": true
          },
          "id": {
            "type": "number",
            "nullable": true
          },
          "mandatory": {
            "type": "boolean"
          }
        },
        "required": [
          "description",
          "id",
          "mandatory"
        ]
      },
      "HpComponentNotFullV2": {
        "type": "object",
        "properties": {
          "generalArticles": {
            "nullable": true,
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/HpGeneralArticle"
            }
          },
          "loDirection": {
            "type": "string",
            "nullable": true
          },
          "loX": {
            "type": "number",
            "nullable": true
          },
          "loY": {
            "type": "number",
            "nullable": true
          },
          "name": {
            "type": "string",
            "nullable": true
          },
          "number": {
            "type": "string",
            "nullable": true
          },
          "shieldPinId": {
            "type": "number",
            "nullable": true
          },
          "slImagesId": {
            "type": "number",
            "nullable": true
          },
          "symbolInstanceId": {
            "type": "number",
            "nullable": true
          },
          "systemTypeId": {
            "type": "number",
            "nullable": true
          }
        },
        "required": [
          "generalArticles",
          "loDirection",
          "loX",
          "loY",
          "name",
          "number",
          "shieldPinId",
          "slImagesId",
          "symbolInstanceId",
          "systemTypeId"
        ]
      },
      "HpDiagnosticComponentV2": {
        "type": "object",
        "properties": {
          "component": {
            "nullable": true,
            "allOf": [
              {
                "$ref": "#/components/schemas/HpComponentNotFullV2"
              }
            ]
          },
          "couplingType": {
            "type": "number"
          },
          "system_group_id": {
            "type": "number"
          },
          "system_type_id": {
            "type": "number"
          },
          "systemName": {
            "type": "string",
            "nullable": true
          }
        },
        "required": [
          "component",
          "couplingType",
          "system_group_id",
          "system_type_id"
        ]
      },
      "VariantGroupsWithComponents": {
        "type": "object",
        "properties": {
          "variantGroups": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/VariantGroup"
            }
          },
          "diagnosticComponents": {
            "nullable": true,
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/HpDiagnosticComponentV2"
            }
          }
        },
        "required": [
          "variantGroups",
          "diagnosticComponents"
        ]
      },
      "GetWiringDiagramComponentsDTO": {
        "type": "object",
        "properties": {
          "carTypeId": {
            "type": "number",
            "nullable": false
          },
          "componentIds": {
            "nullable": false,
            "type": "array",
            "items": {
              "type": "number"
            }
          }
        },
        "required": [
          "carTypeId",
          "componentIds"
        ]
      },
      "ElasticEntry": {
        "type": "object",
        "properties": {
          "elasticsearch_id": {
            "type": "string"
          },
          "repair_group_number": {
            "type": "string"
          },
          "main_chapter_id": {
            "type": "string"
          },
          "chapter_id": {
            "type": "string"
          },
          "repair_group_title": {
            "type": "string"
          },
          "main_chapter_title": {
            "type": "string"
          },
          "chapter_title": {
            "type": "string"
          },
          "full_title": {
            "type": "string"
          },
          "file_name": {
            "type": "string"
          },
          "folder_name": {
            "type": "string"
          },
          "chapter_json": {
            "type": "string"
          },
          "xml_document_id": {
            "type": "string"
          },
          "print_number": {
            "type": "string"
          },
          "transmission_type": {
            "type": "string"
          },
          "engine_codes": {
            "type": "string"
          },
          "type_description": {
            "type": "string"
          },
          "sales_type": {
            "type": "string"
          },
          "language": {
            "type": "string"
          }
        },
        "required": [
          "elasticsearch_id",
          "repair_group_number",
          "main_chapter_id",
          "chapter_id",
          "repair_group_title",
          "main_chapter_title",
          "chapter_title",
          "full_title",
          "file_name",
          "folder_name",
          "chapter_json",
          "xml_document_id",
          "print_number",
          "transmission_type",
          "engine_codes",
          "type_description",
          "sales_type",
          "language"
        ]
      },
      "WDElasticEntry": {
        "type": "object",
        "properties": {
          "elasticsearch_id": {
            "type": "string"
          },
          "wd_group_number": {
            "type": "string"
          },
          "wd_group_title": {
            "type": "string"
          },
          "full_title": {
            "type": "string"
          },
          "file_name": {
            "type": "string"
          },
          "folder_name": {
            "type": "string"
          },
          "chapter_json": {
            "type": "string"
          },
          "xml_document_id": {
            "type": "string"
          },
          "print_number": {
            "type": "string"
          },
          "transmission_type": {
            "type": "string"
          },
          "engine_codes": {
            "type": "string"
          },
          "type_description": {
            "type": "array",
            "items": {
              "type": "string"
            }
          },
          "sales_type": {
            "type": "string"
          },
          "model_year": {
            "type": "string"
          },
          "language": {
            "type": "string"
          }
        },
        "required": [
          "elasticsearch_id",
          "wd_group_number",
          "wd_group_title",
          "full_title",
          "file_name",
          "folder_name",
          "chapter_json",
          "xml_document_id",
          "print_number",
          "transmission_type",
          "engine_codes",
          "type_description",
          "sales_type",
          "model_year",
          "language"
        ]
      },
      "SkodaElasticEntry": {
        "type": "object",
        "properties": {
          "elasticsearch_id": {
            "type": "string"
          },
          "repair_group_number": {
            "type": "string"
          },
          "main_chapter_id": {
            "type": "string"
          },
          "chapter_id": {
            "type": "string"
          },
          "repair_group_title": {
            "type": "string"
          },
          "main_chapter_title": {
            "type": "string"
          },
          "chapter_title": {
            "type": "string"
          },
          "full_title": {
            "type": "string"
          },
          "file_name": {
            "type": "string"
          },
          "folder_name": {
            "type": "string"
          },
          "chapter_json": {
            "type": "string"
          },
          "xml_document_id": {
            "type": "string"
          },
          "print_number": {
            "type": "string"
          },
          "transmission_type": {
            "type": "string"
          },
          "engine_codes": {
            "type": "string"
          },
          "type_description": {
            "type": "string"
          },
          "sales_type": {
            "type": "string"
          },
          "language": {
            "type": "string"
          }
        },
        "required": [
          "elasticsearch_id",
          "repair_group_number",
          "main_chapter_id",
          "chapter_id",
          "repair_group_title",
          "main_chapter_title",
          "chapter_title",
          "full_title",
          "file_name",
          "folder_name",
          "chapter_json",
          "xml_document_id",
          "print_number",
          "transmission_type",
          "engine_codes",
          "type_description",
          "sales_type",
          "language"
        ]
      },
      "SeatElasticEntry": {
        "type": "object",
        "properties": {
          "elasticsearch_id": {
            "type": "string"
          },
          "repair_group_number": {
            "type": "string"
          },
          "main_chapter_id": {
            "type": "string"
          },
          "chapter_id": {
            "type": "string"
          },
          "repair_group_title": {
            "type": "string"
          },
          "main_chapter_title": {
            "type": "string"
          },
          "chapter_title": {
            "type": "string"
          },
          "full_title": {
            "type": "string"
          },
          "file_name": {
            "type": "string"
          },
          "folder_name": {
            "type": "string"
          },
          "chapter_json": {
            "type": "string"
          },
          "xml_document_id": {
            "type": "string"
          },
          "print_number": {
            "type": "string"
          },
          "transmission_type": {
            "type": "string"
          },
          "engine_codes": {
            "type": "string"
          },
          "type_description": {
            "type": "string"
          },
          "sales_type": {
            "type": "string"
          },
          "language": {
            "type": "string"
          }
        },
        "required": [
          "elasticsearch_id",
          "repair_group_number",
          "main_chapter_id",
          "chapter_id",
          "repair_group_title",
          "main_chapter_title",
          "chapter_title",
          "full_title",
          "file_name",
          "folder_name",
          "chapter_json",
          "xml_document_id",
          "print_number",
          "transmission_type",
          "engine_codes",
          "type_description",
          "sales_type",
          "language"
        ]
      },
      "AudiElasticEntry": {
        "type": "object",
        "properties": {
          "elasticsearch_id": {
            "type": "string"
          },
          "repair_group_number": {
            "type": "string"
          },
          "main_chapter_id": {
            "type": "string"
          },
          "chapter_id": {
            "type": "string"
          },
          "repair_group_title": {
            "type": "string"
          },
          "main_chapter_title": {
            "type": "string"
          },
          "chapter_title": {
            "type": "string"
          },
          "full_title": {
            "type": "string"
          },
          "file_name": {
            "type": "string"
          },
          "folder_name": {
            "type": "string"
          },
          "chapter_json": {
            "type": "string"
          },
          "xml_document_id": {
            "type": "string"
          },
          "print_number": {
            "type": "string"
          },
          "transmission_type": {
            "type": "string"
          },
          "engine_codes": {
            "type": "string"
          },
          "type_description": {
            "type": "string"
          },
          "sales_type": {
            "type": "string"
          },
          "language": {
            "type": "string"
          }
        },
        "required": [
          "elasticsearch_id",
          "repair_group_number",
          "main_chapter_id",
          "chapter_id",
          "repair_group_title",
          "main_chapter_title",
          "chapter_title",
          "full_title",
          "file_name",
          "folder_name",
          "chapter_json",
          "xml_document_id",
          "print_number",
          "transmission_type",
          "engine_codes",
          "type_description",
          "sales_type",
          "language"
        ]
      },
      "TeslaEntry": {
        "type": "object",
        "properties": {
          "url": {
            "type": "string"
          },
          "guid": {
            "type": "string"
          },
          "tesla_entry_id": {
            "type": "string"
          },
          "main_section_name": {
            "type": "string"
          },
          "main_section_id": {
            "type": "number"
          },
          "sub_section_name": {
            "type": "string"
          },
          "sub_section_id": {
            "type": "number"
          },
          "issue_page_name": {
            "type": "string"
          },
          "breadcrumb": {
            "type": "string"
          },
          "correction_code": {
            "type": "string"
          },
          "content": {
            "type": "string"
          },
          "model": {
            "type": "string"
          },
          "model_year": {
            "type": "string"
          }
        },
        "required": [
          "url",
          "guid",
          "tesla_entry_id",
          "main_section_name",
          "main_section_id",
          "sub_section_name",
          "sub_section_id",
          "issue_page_name",
          "breadcrumb",
          "correction_code",
          "content",
          "model",
          "model_year"
        ]
      },
      "ServiceHealthStatus": {
        "type": "object",
        "properties": {
          "status": {
            "type": "string",
            "enum": [
              "green",
              "yellow",
              "red"
            ],
            "example": "green"
          },
          "name": {
            "type": "string",
            "example": "HaynesProApiClientService"
          }
        },
        "required": [
          "status",
          "name"
        ]
      },
      "ImageFileDto": {
        "type": "object",
        "properties": {
          "image": {
            "type": "string",
            "format": "binary",
            "description": "An image file"
          }
        },
        "required": [
          "image"
        ]
      },
      "VartaVehicleInformation": {
        "type": "object",
        "properties": {
          "name": {
            "type": "string"
          },
          "details": {
            "type": "object",
            "properties": {
              "modeltype": {
                "type": "string"
              },
              "manufacturer": {
                "type": "string"
              },
              "kw": {
                "type": "string"
              },
              "ps": {
                "type": "string"
              },
              "label": {
                "type": "string"
              },
              "startStopOnly": {
                "type": "object"
              },
              "hasStartStopOption": {
                "type": "object"
              },
              "hasConventionalOption": {
                "type": "object"
              },
              "hasComplexityOption": {
                "type": "object"
              },
              "hasDiagnosticOption": {
                "type": "object"
              },
              "constructionYearFrom": {
                "type": "number"
              },
              "constructionYearTo": {
                "type": "number"
              }
            },
            "required": [
              "modeltype",
              "manufacturer",
              "kw",
              "ps",
              "label",
              "startStopOnly",
              "hasStartStopOption",
              "hasConventionalOption",
              "hasComplexityOption",
              "hasDiagnosticOption",
              "constructionYearFrom",
              "constructionYearTo"
            ]
          }
        },
        "required": [
          "name",
          "details"
        ]
      },
      "VartaPDF": {
        "type": "object",
        "properties": {
          "eobd_location": {
            "type": "string",
            "nullable": true
          },
          "battery_location": {
            "type": "string",
            "nullable": true
          }
        },
        "required": [
          "eobd_location",
          "battery_location"
        ]
      },
      "VartaBatteryDetails": {
        "type": "object",
        "properties": {
          "article_no": {
            "type": "string"
          },
          "type_no": {
            "type": "number"
          },
          "productline_no": {
            "type": "number"
          },
          "productline_no_orig": {
            "type": "number"
          },
          "article_status": {
            "type": "string"
          },
          "uk_no": {
            "type": "string"
          },
          "id": {
            "type": "number"
          },
          "short_code": {
            "type": "string"
          },
          "etn": {
            "type": "string"
          },
          "productline": {
            "type": "string"
          },
          "brand_no": {
            "type": "number"
          },
          "recommendation": {
            "type": "object"
          },
          "upgrade": {
            "type": "object"
          },
          "alternative": {
            "type": "object"
          },
          "auxiliary": {
            "type": "object"
          },
          "startstop": {
            "type": "object"
          },
          "conventional": {
            "type": "object"
          },
          "complexityindicator": {
            "type": "object"
          },
          "diagnosticmarker": {
            "type": "object"
          },
          "api_status_label": {
            "type": "object"
          },
          "ah": {
            "type": "string"
          },
          "cca": {
            "type": "string"
          },
          "voltage": {
            "type": "string"
          },
          "width": {
            "type": "number"
          },
          "height": {
            "type": "number"
          },
          "length": {
            "type": "number"
          },
          "mounting_angle": {
            "type": "number",
            "nullable": true
          },
          "mounting_upright": {
            "type": "number",
            "nullable": true
          },
          "case_size": {
            "type": "string"
          },
          "meta_code": {
            "type": "number",
            "nullable": true
          }
        },
        "required": [
          "article_no",
          "type_no",
          "productline_no",
          "productline_no_orig",
          "article_status",
          "uk_no",
          "id",
          "short_code",
          "etn",
          "productline",
          "brand_no",
          "recommendation",
          "upgrade",
          "alternative",
          "auxiliary",
          "startstop",
          "conventional",
          "complexityindicator",
          "diagnosticmarker",
          "api_status_label",
          "ah",
          "cca",
          "voltage",
          "width",
          "height",
          "length",
          "mounting_angle",
          "mounting_upright",
          "case_size",
          "meta_code"
        ]
      },
      "VartaKeyBenefit": {
        "type": "object",
        "properties": {
          "textNo": {
            "type": "number"
          },
          "shortText": {
            "type": "string"
          },
          "text": {
            "type": "string"
          },
          "sortOrder": {
            "type": "number"
          },
          "title": {
            "type": "string"
          },
          "iconUrl": {
            "type": "string"
          }
        },
        "required": [
          "textNo",
          "shortText",
          "text",
          "sortOrder",
          "title",
          "iconUrl"
        ]
      },
      "VartaDrawing": {
        "type": "object",
        "properties": {
          "name": {
            "type": "string"
          },
          "type": {
            "type": "object"
          },
          "image": {
            "type": "string"
          }
        },
        "required": [
          "name",
          "type",
          "image"
        ]
      },
      "VartaBattery": {
        "type": "object",
        "properties": {
          "details": {
            "$ref": "#/components/schemas/VartaBatteryDetails"
          },
          "image": {
            "type": "string"
          },
          "thumbnails": {
            "type": "array",
            "items": {
              "type": "string"
            }
          },
          "keybenefits": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/VartaKeyBenefit"
            }
          },
          "drawings": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/VartaDrawing"
            }
          },
          "productsheet": {
            "type": "string"
          }
        },
        "required": [
          "details",
          "image",
          "thumbnails",
          "keybenefits",
          "drawings",
          "productsheet"
        ]
      },
      "VartaVehiclePositionInformation": {
        "type": "object",
        "properties": {
          "statusCode": {
            "type": "number"
          },
          "message": {
            "type": "string"
          }
        },
        "required": [
          "statusCode",
          "message"
        ]
      },
      "VartaBatteryReplacementInformation": {
        "type": "object",
        "properties": {
          "statusCode": {
            "type": "number"
          },
          "message": {
            "type": "string"
          }
        },
        "required": [
          "statusCode",
          "message"
        ]
      },
      "VartaData": {
        "type": "object",
        "properties": {
          "permission": {
            "type": "array",
            "items": {
              "type": "object"
            }
          },
          "description": {
            "type": "string"
          },
          "vehicleInformations": {
            "$ref": "#/components/schemas/VartaVehicleInformation"
          },
          "pdf": {
            "$ref": "#/components/schemas/VartaPDF"
          },
          "batteries": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/VartaBattery"
            }
          },
          "vehiclePositionInformations": {
            "$ref": "#/components/schemas/VartaVehiclePositionInformation"
          },
          "batteryReplacementInformations": {
            "$ref": "#/components/schemas/VartaBatteryReplacementInformation"
          }
        },
        "required": [
          "permission",
          "description",
          "vehicleInformations",
          "pdf",
          "batteries",
          "vehiclePositionInformations",
          "batteryReplacementInformations"
        ]
      }
    }
  }
}